// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   AgentShowcase — Growfit 전문 에이전트
   다크 네이비 기반 에디토리얼 톤. 헤어라인 인덱스 + 세리프 번호.
   브랜드 컬러(네이비)는 이 페이지 로컬 토큰으로만 정의 — 전역 토큰 미변경.
   고정 헤더/사이드바 레이아웃(.prompt__layout) 안에서 .prompt__main 스크롤 영역만 사용.
   ============================================================ */

.gf-showcase-page {
  --gf-ink: #0e1b2b;            /* 헤딩용 near-black 네이비 */
  --gf-navy: #13314f;           /* 브랜드 네이비 */
  --gf-navy-soft: #3c5a78;      /* 보조 네이비 */
  --gf-muted: #5c6b7a;          /* 본문 보조 */
  --gf-faint: #8a98a6;          /* 약한 텍스트 */
  --gf-line: rgba(14, 27, 43, 0.12);
  --gf-line-strong: rgba(14, 27, 43, 0.22);
  --gf-brass: #9a7b4f;          /* 절제된 황동 액센트(소량) */
  --gf-serif: "Newsreader", Georgia, serif;
}

/* 배경은 다른 페이지와 동일하게(.prompt__main 기본 흰색) 유지 */
.gf-showcase-page .prompt__content {
  padding: 56px 60px 72px;
}

/* ============================================================
   목록 — 에디토리얼 인덱스
   ============================================================ */
.gf-showcase {
  max-width: 1180px;
}

/* ── 마스트헤드 ── */
.gf-showcase__mast {
  opacity: 0;
  animation: gfRise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) forwards;
}

.gf-showcase__eyebrow {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--gf-navy-soft);
}

.gf-showcase__eyebrow::before {
  content: "";
  flex: none;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--gf-brass);
}

.gf-showcase__headline {
  margin: 20px 0 0;
  font-size: 42px;
  line-height: 1.14;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: var(--gf-ink);
}

.gf-showcase__headline .gf-dim {
  color: var(--gf-faint);
  font-weight: 300;
}

.gf-showcase__deck {
  margin: 18px 0 0;
  max-width: 640px;
  font-size: 15px;
  line-height: 1.7;
  color: var(--gf-muted);
  word-break: keep-all;
}

.gf-showcase__rule {
  margin: 38px 0 0;
  height: 1px;
  background: var(--gf-line-strong);
}

/* ── 인덱스 ── */
.gf-showcase__index {
  margin: 0;
  padding: 0;
  list-style: none;
}

.gf-item {
  position: relative;
  display: grid;
  grid-template-columns: 88px 1fr 40px;
  align-items: start;
  gap: 8px;
  padding: 30px 8px 28px;
  border-bottom: 1px solid var(--gf-line);
  cursor: pointer;
  opacity: 0;
  transform: translateY(10px);
  animation: gfRise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) forwards;
  transition: background 0.35s ease;
}

.gf-item:hover {
  background: linear-gradient(90deg, rgba(19, 49, 79, 0.05), rgba(19, 49, 79, 0) 72%);
}

.gf-item:focus-visible {
  outline: none;
  background: linear-gradient(90deg, rgba(19, 49, 79, 0.07), rgba(19, 49, 79, 0) 72%);
}

.gf-item__num {
  font-family: var(--gf-serif);
  font-style: italic;
  font-weight: 300;
  font-size: 46px;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--gf-faint);
  transition: color 0.35s ease;
}

.gf-item:hover .gf-item__num {
  color: var(--gf-navy);
}

.gf-item__name {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--gf-ink);
}

.gf-item__official {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 12px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--gf-brass);
  vertical-align: middle;
}

.gf-item__official::before {
  content: "";
  width: 5px;
  height: 5px;
  border: 1px solid var(--gf-brass);
  border-radius: 50%;
}

.gf-item__desc {
  margin: 10px 0 0;
  max-width: 820px;
  font-size: 14px;
  line-height: 1.65;
  color: var(--gf-muted);
}

.gf-item__meta {
  margin: 16px 0 0;
  display: flex;
  align-items: baseline;
  gap: 12px;
  font-size: 12.5px;
}

.gf-item__meta-k {
  flex: none;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--gf-navy);
}

.gf-item__meta-v {
  color: var(--gf-faint);
  line-height: 1.5;
}

.gf-item__tags {
  margin: 9px 0 0;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: var(--gf-faint);
}

.gf-item__arrow {
  justify-self: end;
  align-self: center;
  display: inline-flex;
  color: var(--gf-line-strong);
  transition: color 0.35s ease, transform 0.35s ease;
}

.gf-item:hover .gf-item__arrow {
  color: var(--gf-navy);
  transform: translateX(4px);
}

/* 스태거 로드 */
.gf-showcase__mast { animation-delay: 0s; }
.gf-item:nth-child(1) { animation-delay: 0.06s; }
.gf-item:nth-child(2) { animation-delay: 0.15s; }
.gf-item:nth-child(3) { animation-delay: 0.24s; }
.gf-item:nth-child(4) { animation-delay: 0.33s; }
.gf-item:nth-child(5) { animation-delay: 0.42s; }

@keyframes gfRise {
  to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .gf-showcase__mast,
  .gf-item { animation: none; opacity: 1; transform: none; }
}

/* ============================================================
   상세 — 에디토리얼 아티클
   ============================================================ */
.gf-detail {
  max-width: 720px;
  opacity: 0;
  animation: gfRise 0.6s cubic-bezier(0.2, 0.7, 0.2, 1) forwards;
}

.gf-detail__back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 30px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--gf-faint);
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.25s ease;
}

.gf-detail__back:hover {
  color: var(--gf-navy);
}

/* 헤드 */
.gf-detail__eyebrow {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--gf-brass);
}

.gf-detail__eyebrow::before {
  content: "";
  flex: none;
  width: 5px;
  height: 5px;
  border: 1px solid var(--gf-brass);
  border-radius: 50%;
}

.gf-detail__name {
  margin: 16px 0 0;
  font-size: 34px;
  line-height: 1.2;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: var(--gf-ink);
}

.gf-detail__deck {
  margin: 16px 0 0;
  font-size: 15.5px;
  line-height: 1.68;
  color: var(--gf-muted);
  max-width: 600px;
  word-break: keep-all;
  text-wrap: pretty;
}

/* 해자 풀-쿼트 */
.gf-detail__quote {
  margin: 30px 0 0;
  padding: 4px 0 4px 22px;
  border-left: 2px solid var(--gf-navy);
}

.gf-detail__quote-label {
  display: block;
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--gf-navy);
}

.gf-detail__quote-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.62;
  color: var(--gf-ink);
}

/* 섹션 */
.gf-detail__sec {
  margin-top: 40px;
  padding-top: 28px;
  border-top: 1px solid var(--gf-line);
}

.gf-detail__label {
  margin: 0 0 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--gf-navy-soft);
}

/* 무엇을 하나 — 대시 리스트 */
.gf-detail__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.gf-detail__list-item {
  position: relative;
  padding: 0 0 0 22px;
  margin: 12px 0;
  font-size: 14.5px;
  line-height: 1.62;
  color: var(--gf-muted);
}

.gf-detail__list-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 12px;
  height: 1px;
  background: var(--gf-navy);
}

/* 전문성의 근거 — 하어라인 분리 행 */
.gf-detail__evidence {
  display: flex;
  flex-direction: column;
}

.gf-detail__evidence-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 2px;
  font-size: 14px;
  color: var(--gf-ink);
  border-top: 1px solid var(--gf-line);
}

.gf-detail__evidence-item:first-child {
  border-top: none;
}

.gf-detail__evidence-item::before {
  content: "";
  flex: none;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--gf-brass);
}

/* 예시 질문 */
.gf-detail__samples {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gf-detail__sample {
  position: relative;
  margin: 0;
  padding: 13px 16px 13px 40px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--gf-ink);
  background: rgba(19, 49, 79, 0.035);
  border-radius: 2px;
}

.gf-detail__sample::before {
  content: "\\201C";
  position: absolute;
  left: 14px;
  top: 6px;
  font-family: var(--gf-serif);
  font-style: italic;
  font-size: 28px;
  line-height: 1;
  color: var(--gf-brass);
}

/* CTA */
.gf-detail__cta {
  margin-top: 44px;
}

.gf-detail__cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 28px;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  background: var(--gf-navy);
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;
}

.gf-detail__cta-btn:hover {
  background: var(--gf-ink);
  transform: translateY(-1px);
}

.gf-detail__empty {
  font-size: 14px;
  color: var(--gf-muted);
}

/* ── 이어서 하기 — 지난 대화(run) 목록 (CTA 아래) ── */
.gf-resume__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gf-resume__row {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 18px;
  background: rgba(19, 49, 79, 0.025);
  border: 1px solid var(--gf-line);
  border-radius: 2px;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.gf-resume__row:hover {
  background: rgba(19, 49, 79, 0.05);
  border-color: var(--gf-line-strong);
  transform: translateX(2px);
}

.gf-resume__dot {
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--gf-faint);
}

.gf-resume__dot--paused { background: var(--gf-brass); }
.gf-resume__dot--done { background: var(--gf-navy); }
.gf-resume__dot--error { background: #c0492f; }
.gf-resume__dot--running { background: var(--gf-navy-soft); }

.gf-resume__body {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.gf-resume__title {
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  color: var(--gf-ink);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gf-resume__date {
  font-size: 12px;
  color: var(--gf-faint);
  font-variant-numeric: tabular-nums;
}

.gf-resume__action {
  flex: none;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--gf-navy);
}

/* 이어하기 더 보기/접기 토글 */
.gf-resume__more {
  width: 100%;
  margin-top: 8px;
  padding: 10px;
  background: transparent;
  border: 1px solid var(--gf-line);
  border-radius: 2px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gf-navy);
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.gf-resume__more:hover {
  background: rgba(19, 49, 79, 0.04);
  border-color: var(--gf-line-strong);
}

/* ============================================================
   작업 화면 — 좌: 대화 / 우: 산출물 패널(자동 오픈)
   목록·상세와 동일한 네이비 에디토리얼 언어.
   ============================================================ */

/* 다른 페이지와 동일한 카드형 셸 (헤더 아래 전체 영역) */
.gf-work-page .gf-work {
  display: flex;
  flex-direction: column;
  margin: 0 16px;
  min-height: calc(100vh - 52px);
  height: calc(100vh - 52px);
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);
  overflow: hidden;
}

/* 에이전트 식별 바 */
.gf-work__bar {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 56px;
  padding: 0 22px;
  border-bottom: 1px solid var(--gf-line);
}

.gf-work__bar-name {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gf-ink);
}

.gf-work__bar-tag {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--gf-brass);
  border: 1px solid rgba(154, 123, 79, 0.4);
  border-radius: 999px;
  padding: 2px 9px;
}

.gf-work__bar-close {
  margin-left: auto;
  display: inline-flex;
  padding: 6px;
  color: var(--gf-faint);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  transition: color 0.2s ease, background 0.2s ease;
}

.gf-work__bar-close:hover {
  color: var(--gf-ink);
  background: rgba(14, 27, 43, 0.05);
}

/* 상단 바 "수집 정보" 버튼 — 우측 정렬(close 앞) */
.gf-work__bar-info {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gf-navy);
  background: none;
  border: 1px solid var(--gf-line-strong);
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.gf-work__bar-info:hover {
  background: rgba(14, 27, 43, 0.05);
  border-color: var(--gf-navy);
}
.gf-work__bar-info + .gf-work__bar-close { margin-left: 0; }

/* 수집 정보 모달 — 인테이크 폼(.gf-intake) 셸·그룹·라벨 재사용, 읽기 전용 변형.
   폼 전용 추가 규칙만 여기 둔다(셸/그룹/라벨/푸터는 .gf-intake 원본 그대로). */
.gf-intake__head--review {
  position: relative;
  padding-bottom: 22px;
}
/* 헤더 우상단 닫기 — 스텝퍼가 없는 리뷰 모달용 */
.gf-intake__review-close {
  position: absolute;
  top: 18px;
  right: 18px;
  display: inline-flex;
  padding: 6px;
  color: var(--gf-faint);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 6px;
}
.gf-intake__review-close:hover { color: var(--gf-ink); background: rgba(14, 27, 43, 0.05); }
/* 읽기 전용 값 — 폼 컨트롤 자리에 정적 텍스트 */
.gf-intake__value {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--gf-ink);
  word-break: break-word;
}
.gf-intake__review-state {
  padding: 28px 0;
  font-size: 13px;
  color: var(--gf-muted);
  text-align: center;
}

/* 무대(대화 | 패널) */
.gf-work__stage {
  flex: 1 1;
  display: flex;
  min-height: 0;
}

/* 대화 컬럼 */
.gf-work__chat {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.gf-work__scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 36px 0 12px;
}

.gf-work__col {
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 0 32px;
}

/* 메시지 */
.gf-msg {
  margin-bottom: 24px;
}

.gf-msg__who {
  display: block;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--gf-faint);
  margin-bottom: 8px;
}

.gf-msg--user {
  text-align: right;
}

.gf-msg__text {
  margin: 0;
  font-size: 14.5px;
  line-height: 1.72;
  color: #26323f;
}

.gf-msg--user .gf-msg__body {
  display: inline-block;
  text-align: left;
  max-width: 80%;
  padding: 12px 16px;
  background: rgba(19, 49, 79, 0.06);
  border-radius: 12px 12px 4px 12px;
}

.gf-msg--user .gf-msg__text {
  color: var(--gf-ink);
  font-size: 14px;
}

/* 대화 속 아티팩트 칩 */
.gf-work__chip {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  margin-top: 12px;
  padding: 11px 15px;
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.gf-work__chip:hover {
  border-color: var(--gf-navy);
  box-shadow: 0 2px 10px rgba(14, 27, 43, 0.08);
}

.gf-work__chip-ic {
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: rgba(19, 49, 79, 0.08);
  color: var(--gf-navy);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

.gf-work__chip-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--gf-ink);
}

.gf-work__chip-meta {
  display: block;
  font-size: 11px;
  color: var(--gf-faint);
  margin-top: 1px;
}

.gf-work__chip-go {
  margin-left: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--gf-navy-soft);
}

/* 입력부 */
.gf-work__composer {
  padding-top: 14px;
  padding-bottom: 24px;
}

.gf-work__starters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.gf-work__starter {
  font-size: 12.5px;
  color: var(--gf-navy);
  background: rgba(19, 49, 79, 0.05);
  border: 1px solid var(--gf-line);
  border-radius: 999px;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.gf-work__starter:hover {
  background: rgba(19, 49, 79, 0.1);
}

.gf-work__input {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px 11px 16px;
  border: 1px solid var(--gf-line-strong);
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.2s ease;
}

.gf-work__input:focus-within {
  border-color: var(--gf-navy);
}

.gf-work__input-field {
  flex: 1 1;
  border: none;
  outline: none;
  background: none;
  font-size: 14px;
  color: var(--gf-ink);
  font-family: inherit;
}

.gf-work__send {
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--gf-navy);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.gf-work__send:hover {
  background: var(--gf-ink);
}

/* ── 입력창 첨부 버튼 ── */
.gf-work__attach-btn {
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: transparent;
  color: rgba(19, 49, 79, 0.55);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.gf-work__attach-btn:hover {
  background: rgba(19, 49, 79, 0.07);
  color: var(--gf-navy);
}

.gf-work__attach-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* ── 선택된 첨부 칩(입력창 위) ── */
.gf-work__attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.gf-work__attach {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 260px;
  padding: 6px 8px 6px 10px;
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 8px;
  font-size: 12.5px;
  color: var(--gf-ink);
}

.gf-work__attach-ic {
  flex: none;
  display: flex;
  color: rgba(19, 49, 79, 0.55);
}

.gf-work__attach-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gf-work__attach-size {
  flex: none;
  color: rgba(19, 49, 79, 0.5);
  font-size: 11.5px;
}

.gf-work__attach-x {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: rgba(19, 49, 79, 0.5);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.gf-work__attach-x:hover {
  background: rgba(19, 49, 79, 0.08);
  color: var(--gf-navy);
}

/* ── 보낸 메시지 버블의 첨부 칩 ── */
.gf-msg__files {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.gf-msg__file {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 240px;
  padding: 5px 9px;
  background: rgba(19, 49, 79, 0.05);
  border: 1px solid var(--gf-line);
  border-radius: 7px;
  font-size: 12px;
  color: var(--gf-ink);
}

.gf-msg__file-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gf-msg__file-size {
  flex: none;
  color: rgba(19, 49, 79, 0.5);
  font-size: 11px;
}

/* ── 우측 아티팩트 패널 ── */
.gf-work__panel {
  flex: none;
  width: 880px;
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--gf-line);
  background: #fff;
  overflow: hidden;
  animation: gfPanelIn 0.42s cubic-bezier(0.2, 0.7, 0.2, 1);
}

@keyframes gfPanelIn {
  from { width: 0; opacity: 0; }
  to { width: 880px; opacity: 1; }
}

.gf-work__panel-head {
  flex: none;
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 16px;
  border-bottom: 1px solid var(--gf-line);
}

.gf-work__panel-title {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--gf-navy-soft);
}

.gf-work__panel-close {
  margin-left: auto;
  display: inline-flex;
  padding: 5px;
  color: var(--gf-faint);
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease;
}

.gf-work__panel-close:hover {
  color: var(--gf-ink);
  background: rgba(14, 27, 43, 0.05);
}

.gf-work__panel-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 26px 28px;
  animation: gfFadeIn 0.3s ease;
}

/* 패널은 열린 채로 두고 본문만 교체될 때의 부드러운 전환 */
@keyframes gfFadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
}

.gf-work__panel-foot {
  flex: none;
  display: flex;
  gap: 8px;
  padding: 13px 16px;
  border-top: 1px solid var(--gf-line);
}

.gf-work__panel-btn {
  flex: 1 1;
  height: 38px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gf-navy);
  background: none;
  border: 1px solid var(--gf-line-strong);
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
}

.gf-work__panel-btn:hover {
  border-color: var(--gf-navy);
  color: var(--gf-ink);
}

/* 폼 아티팩트 */
.gf-form__title {
  margin: 0 0 5px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gf-ink);
}

.gf-form__sub {
  margin: 0 0 20px;
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--gf-muted);
}

.gf-form__field {
  margin-bottom: 15px;
}

.gf-form__field label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--gf-navy);
  margin-bottom: 7px;
}

.gf-form__ctrl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  padding: 0 13px;
  font-size: 13px;
  color: var(--gf-ink);
  border: 1px solid var(--gf-line-strong);
  border-radius: 8px;
}

.gf-form__ctrl span {
  color: var(--gf-faint);
}

.gf-form__submit {
  margin-top: 10px;
  width: 100%;
  height: 44px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #fff;
  background: var(--gf-navy);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.gf-form__submit:hover {
  background: var(--gf-ink);
}

/* 결과 아티팩트 — 상세의 evidence 행과 동일 언어 */
.gf-result__row {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 14px 2px;
  border-bottom: 1px solid var(--gf-line);
}

.gf-result__row:first-child {
  border-top: 1px solid var(--gf-line);
}

.gf-result__dot {
  flex: none;
  width: 7px;
  height: 7px;
  border-radius: 2px;
  background: var(--gf-navy);
}

.gf-result__main {
  flex: 1 1;
  min-width: 0;
}

.gf-result__name {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--gf-ink);
}

.gf-result__sub {
  margin-top: 3px;
  font-size: 11.5px;
  color: var(--gf-faint);
}

.gf-result__dday {
  flex: none;
  font-family: var(--gf-serif);
  font-style: italic;
  font-size: 15px;
  font-weight: 500;
  color: var(--gf-brass);
}

@media (max-width: 1380px) {
  .gf-work__panel { width: 620px; }
  @keyframes gfPanelIn { from { width: 0; opacity: 0; } to { width: 620px; opacity: 1; } }
}

@media (max-width: 1040px) {
  .gf-work__panel { width: 460px; }
  @keyframes gfPanelIn { from { width: 0; opacity: 0; } to { width: 460px; opacity: 1; } }
}

/* ============================================================
   아티팩트 렌더러 — 범용 type별 (동일 네이비 에디토리얼 언어)
   ============================================================ */

/* upload */
.gf-upload__drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  padding: 30px 16px;
  margin-bottom: 14px;
  color: var(--gf-navy-soft);
  text-align: center;
  border: 1.5px dashed var(--gf-line-strong);
  border-radius: 10px;
  background: rgba(19, 49, 79, 0.02);
}

.gf-upload__drop-text { font-size: 13px; color: var(--gf-muted); }
.gf-upload__hint { font-size: 11.5px; color: var(--gf-faint); }

/* connect (OAuth) */
.gf-connect__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  margin-bottom: 14px;
  border: 1px solid var(--gf-line-strong);
  border-radius: 10px;
}

.gf-connect__logo {
  flex: none;
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: rgba(19, 49, 79, 0.08);
  color: var(--gf-navy);
  display: flex;
  align-items: center;
  justify-content: center;
}

.gf-connect__info { flex: 1 1; min-width: 0; }
.gf-connect__name { font-size: 14px; font-weight: 700; color: var(--gf-ink); }
.gf-connect__desc { margin-top: 2px; font-size: 11.5px; color: var(--gf-faint); }
.gf-connect__status {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--gf-faint);
  border: 1px solid var(--gf-line);
  border-radius: 999px;
  padding: 3px 9px;
}

/* choice */
.gf-choice { display: flex; flex-direction: column; gap: 9px; margin-bottom: 14px; }

.gf-choice__opt {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 13px 14px;
  border: 1px solid var(--gf-line-strong);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.gf-choice__opt:hover { border-color: var(--gf-navy); }
.gf-choice__opt input { margin-top: 3px; accent-color: var(--gf-navy); }
.gf-choice__opt-body { display: flex; flex-direction: column; gap: 3px; }
.gf-choice__opt-title { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }
.gf-choice__opt-desc { font-size: 12px; color: var(--gf-faint); }

/* progress */
.gf-progress { display: flex; flex-direction: column; }

.gf-progress__step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 2px;
  border-bottom: 1px solid var(--gf-line);
  font-size: 13.5px;
  color: var(--gf-muted);
}

.gf-progress__step:first-child { border-top: 1px solid var(--gf-line); }
.gf-progress__dot {
  flex: none;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 2px solid var(--gf-line-strong);
  background: transparent;
}

.gf-progress__step--done .gf-progress__dot { background: var(--gf-navy); border-color: var(--gf-navy); }
.gf-progress__step--running .gf-progress__dot { border-color: var(--gf-brass); background: var(--gf-brass); animation: gfPulse 1.1s ease-in-out infinite; }
.gf-progress__step--done .gf-progress__label,
.gf-progress__step--running .gf-progress__label { color: var(--gf-ink); }
.gf-progress__label { flex: 1 1; }
.gf-progress__state { flex: none; font-size: 11px; font-weight: 600; color: var(--gf-faint); }
.gf-progress__step--running .gf-progress__state { color: var(--gf-brass); }

@keyframes gfPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }

/* detail — key/value */
.gf-kv { display: flex; flex-direction: column; }
.gf-kv__row {
  display: flex;
  gap: 14px;
  padding: 12px 2px;
  border-bottom: 1px solid var(--gf-line);
  font-size: 13.5px;
}
.gf-kv__row:first-child { border-top: 1px solid var(--gf-line); }
.gf-kv__k { flex: none; width: 76px; font-weight: 700; color: var(--gf-navy); letter-spacing: 0.02em; }
.gf-kv__v { flex: 1 1; color: var(--gf-ink); line-height: 1.5; }

/* document */
.gf-doc__h {
  margin: 18px 0 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--gf-ink);
  letter-spacing: -0.01em;
}
.gf-doc__h:first-child { margin-top: 0; }
.gf-doc__p { margin: 0; font-size: 13.5px; line-height: 1.7; color: var(--gf-muted); }

/* compare */
.gf-compare { display: flex; flex-direction: column; }
.gf-compare__row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--gf-line);
}
.gf-compare__row--head { border-bottom: 1px solid var(--gf-line-strong); }
.gf-compare__k {
  flex: none;
  width: 84px;
  padding: 11px 8px 11px 2px;
  font-size: 12px;
  font-weight: 700;
  color: var(--gf-navy);
}
.gf-compare__c {
  flex: 1 1;
  padding: 11px 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--gf-ink);
  text-align: center;
}
.gf-compare__v {
  flex: 1 1;
  padding: 11px 8px;
  font-size: 13px;
  color: var(--gf-muted);
  text-align: center;
}

/* checklist */
.gf-check { display: flex; flex-direction: column; }
.gf-check__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 2px;
  border-bottom: 1px solid var(--gf-line);
  font-size: 13.5px;
  color: var(--gf-muted);
}
.gf-check__row:first-child { border-top: 1px solid var(--gf-line); }
.gf-check__box {
  flex: none;
  width: 19px;
  height: 19px;
  border-radius: 5px;
  border: 1.5px solid var(--gf-line-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.gf-check__row--done .gf-check__box { background: var(--gf-navy); border-color: var(--gf-navy); }
.gf-check__row--done .gf-check__label { color: var(--gf-ink); }
.gf-check__label { flex: 1 1; }

/* timeline */
.gf-timeline { display: flex; flex-direction: column; }
.gf-timeline__row { display: flex; gap: 12px; }
.gf-timeline__date {
  flex: none;
  width: 44px;
  padding-top: 1px;
  font-family: var(--gf-serif);
  font-style: italic;
  font-size: 14px;
  color: var(--gf-brass);
}
.gf-timeline__rail { flex: none; position: relative; width: 12px; display: flex; justify-content: center; }
.gf-timeline__rail::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--gf-line);
}
.gf-timeline__row:first-child .gf-timeline__rail::before { top: 6px; }
.gf-timeline__row:last-child .gf-timeline__rail::before { bottom: auto; height: 6px; }
.gf-timeline__dot {
  position: relative;
  margin-top: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid var(--gf-navy);
}
.gf-timeline__body { flex: 1 1; padding: 0 0 20px; }
.gf-timeline__label { display: block; font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }
.gf-timeline__sub { display: block; margin-top: 2px; font-size: 11.5px; color: var(--gf-faint); }

/* state — empty / error / permission */
.gf-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 36px 18px 24px;
}
.gf-state__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  margin-bottom: 16px;
  color: var(--gf-navy-soft);
  background: rgba(19, 49, 79, 0.06);
}
.gf-state--error .gf-state__icon { color: #b4524a; background: rgba(180, 82, 74, 0.1); }
.gf-state--permission .gf-state__icon { color: var(--gf-brass); background: rgba(154, 123, 79, 0.12); }
.gf-state__title { margin: 0 0 6px; font-size: 16px; font-weight: 700; color: var(--gf-ink); }
.gf-state__sub { margin: 0 0 20px; font-size: 13px; line-height: 1.55; color: var(--gf-muted); max-width: 280px; }
.gf-state__btn { width: auto; padding-left: 28px; padding-right: 28px; }

/* preview — 생성 파일(iframe) 뷰어. 패널 본문을 가득 채움 */
.gf-work__panel-body--flush {
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gf-preview {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.gf-preview__bar {
  flex: none;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 18px;
  border-bottom: 1px solid var(--gf-line);
  background: #fff;
}

.gf-preview__file-ic {
  display: inline-flex;
  color: var(--gf-navy);
}

.gf-preview__file-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--gf-ink);
}

.gf-preview__file-type {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--gf-brass);
  border: 1px solid rgba(154, 123, 79, 0.45);
  border-radius: 4px;
  padding: 1px 6px;
}

.gf-preview__stage {
  flex: 1 1;
  min-height: 0;
  display: flex;
  background: #e9e7e2;
}

/* 뷰어는 전체 영역을 채우고, 문서(mock 2페이지 또는 실제 PDF)가 내부에서 스크롤 */
.gf-preview__frame {
  flex: 1 1;
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
}

/* ============================================================
   진입 동의 모달
   ============================================================ */
.gf-consent {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.gf-consent__scrim {
  position: absolute;
  inset: 0;
  background: rgba(14, 27, 43, 0.45);
  animation: gfFadeIn 0.25s ease;
}

.gf-consent__card {
  position: relative;
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 14px;
  padding: 30px 30px 24px;
  box-shadow: 0 30px 70px -20px rgba(14, 27, 43, 0.5);
  animation: gfConsentIn 0.32s cubic-bezier(0.2, 0.7, 0.2, 1);
}

@keyframes gfConsentIn {
  from { opacity: 0; transform: translateY(12px) scale(0.98); }
  to { opacity: 1; transform: none; }
}

.gf-consent__eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--gf-brass);
}

.gf-consent__title {
  margin: 12px 0 0;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--gf-ink);
}

.gf-consent__intro {
  margin: 10px 0 0;
  font-size: 13.5px;
  line-height: 1.6;
  color: var(--gf-muted);
}

/* 전체 동의 토글 버튼 */
.gf-consent__all {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 22px 0 10px;
  padding: 15px 16px;
  border: 1.5px solid var(--gf-navy);
  border-radius: 10px;
  background: rgba(19, 49, 79, 0.03);
  cursor: pointer;
  transition: background 0.2s ease;
}

.gf-consent__all:hover,
.gf-consent__all--on {
  background: rgba(19, 49, 79, 0.06);
}

.gf-consent__all-label {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--gf-ink);
}

.gf-consent__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
}

.gf-consent__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px 16px;
  border: 1px solid var(--gf-line-strong);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.gf-consent__item:hover {
  border-color: var(--gf-navy);
  background: rgba(19, 49, 79, 0.02);
}

.gf-consent__cb {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.gf-consent__box {
  flex: none;
  margin-top: 1px;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid var(--gf-line-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.18s ease, border-color 0.18s ease;
}

.gf-consent__box--on {
  background: var(--gf-navy);
  border-color: var(--gf-navy);
}

.gf-consent__body {
  flex: 1 1;
  min-width: 0;
}

.gf-consent__row-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gf-consent__label {
  font-size: 14px;
  font-weight: 700;
  color: var(--gf-ink);
}

.gf-consent__tag {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: var(--gf-faint);
  border: 1px solid var(--gf-line);
  border-radius: 999px;
  padding: 2px 8px;
}

.gf-consent__tag--req {
  color: var(--gf-navy);
  border-color: rgba(19, 49, 79, 0.35);
}

.gf-consent__desc {
  display: block;
  margin-top: 5px;
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--gf-muted);
}

.gf-consent__foot {
  display: flex;
  gap: 10px;
  margin: 24px 0 0;
}

.gf-consent__btn {
  flex: 1 1;
  height: 46px;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.gf-consent__btn--ghost {
  flex: 0 0 auto;
  padding: 0 20px;
  color: var(--gf-muted);
  background: none;
  border: 1px solid var(--gf-line-strong);
}

.gf-consent__btn--ghost:hover {
  color: var(--gf-ink);
  border-color: var(--gf-navy-soft);
}

.gf-consent__btn--primary {
  color: #fff;
  background: var(--gf-navy);
  border: none;
}

.gf-consent__btn--primary:hover {
  background: var(--gf-ink);
}

.gf-consent__btn--primary:disabled {
  background: var(--gf-line-strong);
  cursor: not-allowed;
}

.gf-consent__note {
  margin: 14px 0 0;
  font-size: 11.5px;
  color: var(--gf-faint);
  text-align: center;
}

/* ============================================================
   프로필 수집 폼 — 활용 전 기업·대표 정보 (2-step 위저드)
   동의 모달과 같은 다크 네이비 에디토리얼 언어. 시트형 대형 카드.
   ============================================================ */
.gf-intake {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
}

.gf-intake__scrim {
  position: absolute;
  inset: 0;
  background: rgba(14, 27, 43, 0.5);
  animation: gfFadeIn 0.25s ease;
}

.gf-intake__card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 760px;
  max-height: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 34px 80px -24px rgba(14, 27, 43, 0.55);
  overflow: hidden;
  animation: gfConsentIn 0.32s cubic-bezier(0.2, 0.7, 0.2, 1);
}

/* ── 헤더 (고정) ── */
.gf-intake__head {
  flex: none;
  padding: 28px 34px 0;
  border-bottom: 1px solid var(--gf-line);
}

.gf-intake__eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--gf-brass);
}

.gf-intake__title {
  margin: 10px 0 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--gf-ink);
}

.gf-intake__sub {
  margin: 9px 0 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--gf-muted);
  max-width: 600px;
  word-break: keep-all;
}

.gf-intake__stepper {
  display: flex;
  gap: 10px;
  margin: 22px 0 0;
}

.gf-intake__stepper-item {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 1 1;
  padding: 13px 16px 15px;
  border-bottom: 2px solid transparent;
  color: var(--gf-faint);
}

.gf-intake__stepper-item.is-current {
  border-bottom-color: var(--gf-navy);
  color: var(--gf-ink);
}

.gf-intake__stepper-item.is-done {
  color: var(--gf-navy-soft);
}

.gf-intake__stepper-num {
  flex: none;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  background: rgba(14, 27, 43, 0.08);
  color: inherit;
}

.gf-intake__stepper-item.is-current .gf-intake__stepper-num {
  background: var(--gf-navy);
  color: #fff;
}

.gf-intake__stepper-item.is-done .gf-intake__stepper-num {
  background: rgba(19, 49, 79, 0.14);
  color: var(--gf-navy);
}

.gf-intake__stepper-label {
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.gf-intake__stepper-tag {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid var(--gf-line-strong);
  color: var(--gf-faint);
}

.gf-intake__stepper-item.is-current .gf-intake__stepper-tag {
  color: var(--gf-navy);
  border-color: rgba(19, 49, 79, 0.35);
}

/* ── 본문 (스크롤) ── */
.gf-intake__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px 34px 30px;
}

.gf-intake__step-desc {
  margin: 0 0 22px;
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--gf-muted);
}

.gf-intake__group {
  padding: 0 0 22px;
  margin-bottom: 22px;
  border-bottom: 1px solid var(--gf-line);
}

.gf-intake__group:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 4px;
}

.gf-intake__group-head {
  margin-bottom: 16px;
}

.gf-intake__group-title {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: var(--gf-navy);
}

.gf-intake__group-desc {
  margin: 6px 0 14px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--gf-muted);
}

/* 결격사유 그룹 — 절제된 경고 톤 */
.gf-intake__group--danger {
  padding: 20px;
  border: 1px solid var(--warning-border, #e7d8b0);
  border-radius: 12px;
  background: var(--fg-bg-warning, #fbf7ec);
}

.gf-intake__group--danger .gf-intake__group-title {
  color: #9a6b1f;
}

/* 필드 그리드 — 2열, full 클래스는 한 줄 차지 */
.gf-intake__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 18px;
}

.gf-intake__field--full,
.gf-intake__grid > .gf-intake__field--full {
  grid-column: 1 / -1;
}

.gf-intake__field {
  min-width: 0;
}

.gf-intake__label {
  display: block;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gf-ink);
  margin-bottom: 8px;
}

.gf-intake__req {
  margin-left: 3px;
  color: var(--gf-brass);
}

.gf-intake__note {
  margin: 7px 0 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--gf-faint);
}

/* select */
.gf-intake__select {
  position: relative;
}

.gf-intake__select-el {
  width: 100%;
  height: 44px;
  padding: 0 38px 0 13px;
  font-size: 13.5px;
  font-family: inherit;
  color: var(--gf-ink);
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 9px;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.gf-intake__select-el:focus {
  outline: none;
  border-color: var(--gf-navy);
  box-shadow: 0 0 0 3px rgba(19, 49, 79, 0.1);
}

.gf-intake__select-el:invalid,
.gf-intake__select-el[value=""] {
  color: var(--gf-faint);
}

.gf-intake__select-ic {
  position: absolute;
  top: 50%;
  right: 13px;
  transform: translateY(-50%);
  color: var(--gf-faint);
  pointer-events: none;
}

.gf-intake__select--err .gf-intake__select-el {
  border-color: var(--error, #d24b4b);
  box-shadow: 0 0 0 3px rgba(210, 75, 75, 0.08);
}

/* date — 설립일 + 미설립(예비창업) 토글 */
.gf-intake__date {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.gf-intake__date-input {
  flex: 1 1;
  min-width: 150px;
  height: 44px;
  padding: 0 13px;
  font-size: 13.5px;
  font-family: inherit;
  color: var(--gf-ink);
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 9px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.gf-intake__date-input:focus {
  outline: none;
  border-color: var(--gf-navy);
  box-shadow: 0 0 0 3px rgba(19, 49, 79, 0.1);
}

.gf-intake__date-input:disabled {
  background: rgba(14, 27, 43, 0.04);
  color: var(--gf-faint);
  cursor: not-allowed;
}

.gf-intake__date-input--err {
  border-color: var(--error, #d24b4b);
  box-shadow: 0 0 0 3px rgba(210, 75, 75, 0.08);
}

.gf-intake__date-pre {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  color: var(--gf-navy-soft);
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 9px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.16s ease;
}

.gf-intake__date-pre:hover {
  border-color: var(--gf-navy-soft);
}

.gf-intake__date-pre--on {
  color: var(--gf-navy);
  border-color: var(--gf-navy);
  background: rgba(19, 49, 79, 0.05);
}

.gf-intake__date-pre-box {
  flex: none;
  width: 17px;
  height: 17px;
  border-radius: 5px;
  border: 1.5px solid var(--gf-line-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.16s ease, border-color 0.16s ease;
}

.gf-intake__date-pre-box--on {
  background: var(--gf-navy);
  border-color: var(--gf-navy);
}

/* segmented / yes-no */
.gf-intake__seg {
  display: inline-flex;
  gap: 6px;
  flex-wrap: wrap;
}

.gf-intake__seg--yn {
  width: 100%;
}

.gf-intake__seg-btn {
  min-width: 64px;
  height: 40px;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  color: var(--gf-navy-soft);
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.16s ease;
}

.gf-intake__seg--yn .gf-intake__seg-btn {
  flex: 1 1;
}

.gf-intake__seg-btn:hover {
  border-color: var(--gf-navy-soft);
}

.gf-intake__seg-btn--on {
  color: #fff;
  background: var(--gf-navy);
  border-color: var(--gf-navy);
}

.gf-intake__seg-btn--danger-on {
  color: #fff;
  background: #c2611f;
  border-color: #c2611f;
}

/* chips (다중) */
.gf-intake__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  padding: 2px;
  border-radius: 10px;
}

.gf-intake__chips--err {
  outline: 2px solid rgba(210, 75, 75, 0.18);
  outline-offset: 4px;
}

.gf-intake__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 15px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  color: var(--gf-navy);
  background: rgba(19, 49, 79, 0.04);
  border: 1px solid var(--gf-line);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.16s ease;
}

.gf-intake__chip:hover {
  border-color: var(--gf-navy-soft);
  background: rgba(19, 49, 79, 0.07);
}

.gf-intake__chip--on {
  color: #fff;
  background: var(--gf-navy);
  border-color: var(--gf-navy);
}

.gf-intake__chip-ck {
  display: inline-flex;
}

/* text */
.gf-intake__text {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  font-size: 13.5px;
  font-family: inherit;
  color: var(--gf-ink);
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 9px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.gf-intake__text:focus {
  outline: none;
  border-color: var(--gf-navy);
  box-shadow: 0 0 0 3px rgba(19, 49, 79, 0.1);
}

.gf-intake__text::placeholder {
  color: var(--gf-faint);
}

/* progressive disclosure 게이트 */
.gf-intake__gate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 13px 16px;
  margin-bottom: 16px;
  background: rgba(19, 49, 79, 0.03);
  border: 1px solid var(--gf-line);
  border-radius: 10px;
}

.gf-intake__gate-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--gf-ink);
}

.gf-intake__gate .gf-intake__seg--yn {
  width: auto;
  flex: none;
}

.gf-intake__gate .gf-intake__seg-btn {
  flex: none;
  min-width: 60px;
}

/* 민감정보 인라인 동의 */
/* 단일 체크박스 필드(commitment 등) */
.gf-intake__checkbox {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
}
.gf-intake__checkbox:hover { border-color: var(--gf-navy-soft); }
.gf-intake__checkbox--on { border-color: var(--gf-navy); background: rgba(19, 49, 79, 0.05); }
.gf-intake__checkbox-box {
  width: 18px;
  height: 18px;
  flex: none;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--gf-line-strong);
  border-radius: 5px;
  color: #fff;
}
.gf-intake__checkbox-box--on { background: var(--gf-navy); border-color: var(--gf-navy); }
.gf-intake__checkbox-label { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); line-height: 1.45; }

.gf-intake__sensitive {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.gf-intake__consent {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
  text-align: left;
  padding: 14px 15px;
  background: rgba(19, 49, 79, 0.025);
  border: 1px solid var(--gf-line-strong);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
}

.gf-intake__consent:hover {
  border-color: var(--gf-navy-soft);
}

.gf-intake__consent--on {
  border-color: var(--gf-navy);
  background: rgba(19, 49, 79, 0.05);
}

.gf-intake__consent-box {
  flex: none;
  margin-top: 1px;
  width: 19px;
  height: 19px;
  border-radius: 6px;
  border: 1.5px solid var(--gf-line-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.16s ease, border-color 0.16s ease;
}

.gf-intake__consent-box--on {
  background: var(--gf-navy);
  border-color: var(--gf-navy);
}

.gf-intake__consent-lead {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: var(--gf-ink);
}

.gf-intake__consent-tag {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 1px 7px;
  border-radius: 999px;
  border: 1px solid var(--gf-line);
  color: var(--gf-faint);
}

.gf-intake__consent-desc {
  display: block;
  margin-top: 5px;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--gf-muted);
}

/* 그룹 단위 동의 박스 + 4대 고지(목적·항목·기간·거부권) */
.gf-intake__consent-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gf-intake__consent-meta {
  margin: 0;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: rgba(19, 49, 79, 0.02);
  border: 1px solid var(--gf-line);
  border-radius: 9px;
}

.gf-intake__consent-meta-row {
  display: grid;
  grid-template-columns: 92px 1fr;
  gap: 10px;
  align-items: start;
}

.gf-intake__consent-meta-row dt {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.5;
  color: var(--gf-faint);
}

.gf-intake__consent-meta-row dd {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.55;
  color: var(--gf-muted);
}

.gf-intake__error {
  margin: 18px 0 0;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--error, #d24b4b);
}

/* ── 푸터 (고정) ── */
.gf-intake__foot {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 34px;
  border-top: 1px solid var(--gf-line);
  background: #fff;
}

.gf-intake__foot-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gf-intake__btn {
  height: 46px;
  padding: 0 22px;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.01em;
  font-family: inherit;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.gf-intake__btn--ghost {
  color: var(--gf-muted);
  background: none;
  border: 1px solid var(--gf-line-strong);
}

.gf-intake__btn--ghost:hover {
  color: var(--gf-ink);
  border-color: var(--gf-navy-soft);
}

.gf-intake__btn--text {
  color: var(--gf-muted);
  background: none;
  border: none;
}

.gf-intake__btn--text:hover {
  color: var(--gf-ink);
  text-decoration: underline;
}

.gf-intake__btn--primary {
  color: #fff;
  background: var(--gf-navy);
  border: none;
}

.gf-intake__btn--primary:hover {
  background: var(--gf-ink);
}

.gf-intake__btn--primary:disabled {
  background: var(--gf-line-strong);
  cursor: not-allowed;
}

/* 좁은 화면 */
@media (max-width: 640px) {
  .gf-intake { padding: 0; }
  .gf-intake__card { max-width: none; max-height: 100%; height: 100%; border-radius: 0; }
  .gf-intake__head { padding: 22px 20px 0; }
  .gf-intake__body { padding: 20px 20px 26px; }
  .gf-intake__foot { padding: 14px 20px; }
  .gf-intake__grid { grid-template-columns: 1fr; }
  .gf-intake__btn { padding: 0 16px; }
  .gf-intake__stepper-tag { display: none; }
}

/* ============================================================
   매칭 결과(match_report) — 우측 패널
   적격(녹) / 추가확인(황동) / 아깝게 탈락(약) 3섹션
   ============================================================ */
.gf-match {
  --gf-ok: #2f6f4e;            /* 적격 — 절제된 포레스트 그린 */
  --gf-ok-bg: rgba(47, 111, 78, 0.07);
  --gf-warn: var(--gf-brass);  /* 추가확인 — 황동 */
  --gf-warn-bg: rgba(154, 123, 79, 0.10);
  --gf-warn-ink: #7a5d33;      /* 황동 칩 텍스트 — WCAG AA 확보용 어두운 톤 */
  --gf-danger: #c2410c;        /* 마감 임박 — 어스톤 번트레드(네이비/그린/황동과 조화) */
  --gf-danger-bg: rgba(194, 65, 12, 0.10);
}

/* 탭 — 신청 가능 / 추가 확인 / 아깝게 탈락 */
.gf-match__tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 18px;
  border-bottom: 1px solid var(--gf-line);
}

.gf-match__tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 13px;
  margin-bottom: -1px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--gf-muted);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: var(--transition-fast, 0.15s ease);
}
.gf-match__tab:hover { color: var(--gf-ink); }

.gf-match__tab-count {
  font-size: 11px;
  font-weight: 700;
  min-width: 18px;
  padding: 1px 6px;
  border-radius: var(--radius-full, 9999px);
  color: var(--gf-muted);
  background: rgba(19, 49, 79, 0.08);
}

.gf-match__tab.is-on { color: var(--gf-ink); border-bottom-color: var(--gf-navy); }
.gf-match__tab--eligible.is-on { color: var(--gf-ok); border-bottom-color: var(--gf-ok); }
.gf-match__tab--eligible.is-on .gf-match__tab-count { color: #fff; background: var(--gf-ok); }
.gf-match__tab--warn.is-on,
.gf-match__tab--needs.is-on { color: var(--gf-warn); border-bottom-color: var(--gf-warn); }
.gf-match__tab--needs.is-on .gf-match__tab-count { color: #fff; background: var(--gf-warn); }
.gf-match__tab--near.is-on { color: var(--gf-ink); border-bottom-color: var(--gf-line-strong); }
.gf-match__tab--near.is-on .gf-match__tab-count { color: #fff; background: var(--gf-navy-soft); }

.gf-match__list { display: flex; flex-direction: column; }

.gf-match__hint {
  font-size: 12px;
  color: var(--gf-muted);
  line-height: 1.5;
  padding: 4px 0 10px;
}

.gf-match__row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 13px 10px;
  margin: 0 -10px;              /* hover 배경만 살짝 바깥으로, 구분선은 본문 폭 유지 */
  border-bottom: 1px solid var(--gf-line);
  border-radius: 8px;
}
.gf-match__row:last-child { border-bottom: none; }

/* 상태 구분은 탭(신청가능/추가확인/아깝게탈락)이 담당 — 행 좌측 컬러바는 제거.
   탭 안의 모든 행이 동일 상태라 좌측 보더는 정보 중복이었다. */

.gf-match__main { flex: 1 1; min-width: 0; }

.gf-match__name {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--gf-ink);
  line-height: 1.4;
}

.gf-match__meta {
  font-size: 12px;
  color: var(--gf-muted);
  margin-top: 3px;
}

.gf-match__sum {
  font-size: 12.5px;
  color: var(--gf-navy-soft);
  line-height: 1.55;
  margin-top: 6px;
}

/* 누락/미달 차원 — 인라인 텍스트 대신 칩으로(반복되는 행 사이에서 시선 앵커) */
.gf-match__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}
.gf-match__tags-pre {
  font-size: 11px;
  font-weight: 600;
  color: var(--gf-faint);
  letter-spacing: 0.02em;
}
.gf-match__tag {
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.4;
  padding: 2px 9px;
  border-radius: var(--radius-full, 9999px);
  letter-spacing: -0.01em;
  white-space: nowrap;
}
.gf-match__tag--warn { color: var(--gf-warn-ink); background: var(--gf-warn-bg); }
.gf-match__tag--miss { color: var(--gf-navy-soft); background: rgba(19, 49, 79, 0.07); }

.gf-match__link {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  color: var(--gf-navy);
  text-decoration: none;
  margin-top: 8px;
}
.gf-match__link:hover { text-decoration: underline; }

/* 우측 부가 영역 — 마감 배지 + 클릭 셰브론 세로 정렬 */
.gf-match__aside {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 9px;
  padding-top: 1px;
}

/* 마감 배지 — 톤별 pill. 상시·임박·마감을 색으로 분리(임박이 가장 강하게). */
.gf-match__dday {
  display: inline-flex;
  align-items: center;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  padding: 2px 9px;
  border-radius: var(--radius-full, 9999px);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}
.gf-match__dday--always { font-weight: 600; color: var(--gf-faint); background: rgba(19, 49, 79, 0.06); }
.gf-match__dday--normal { color: var(--gf-navy-soft); background: rgba(19, 49, 79, 0.07); }
.gf-match__dday--soon { color: var(--gf-navy); background: rgba(19, 49, 79, 0.11); }
.gf-match__dday--urgent { color: var(--gf-danger); background: var(--gf-danger-bg); }
.gf-match__dday--closed { font-weight: 600; color: var(--gf-faint); background: rgba(19, 49, 79, 0.05); text-decoration: line-through; }

/* 클릭 가능 행 신호 — 평소 옅게, hover 시 네이비로 또렷이 */
.gf-match__chev {
  display: inline-flex;
  color: var(--gf-faint);
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease;
}
.gf-match__row--click .gf-match__chev { opacity: 0.45; }
.gf-match__row--click:hover .gf-match__chev { opacity: 1; color: var(--gf-navy); }

.gf-match__empty {
  font-size: 13px;
  color: var(--gf-muted);
  text-align: center;
  padding: 28px 12px;
}

/* 추가확인 페이지네이션 */
.gf-match__pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 14px 0 4px;
}
.gf-match__pager-btn {
  border: 1px solid var(--gf-line);
  background: #fff;
  color: var(--gf-navy, #13314f);
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 7px;
  padding: 6px 14px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.gf-match__pager-btn:hover:not(:disabled) {
  background: #f2f5f8;
  border-color: var(--gf-navy, #13314f);
}
.gf-match__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}
.gf-match__pager-info {
  font-size: 12px;
  color: var(--gf-muted);
  font-variant-numeric: tabular-nums;
  min-width: 110px;
  text-align: center;
}

.gf-match__foot {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--gf-line);
  font-size: 11.5px;
  color: var(--gf-muted);        /* faint(대비 ~3:1)는 AA 미달 — muted로 상향 */
  letter-spacing: 0.01em;
}

/* ============================================================
   추가 질문(paused) — 대화 흐름 안
   ============================================================ */
.gf-qa {
  margin-top: 10px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--gf-line);
  border-radius: var(--radius-lg, 8px);
}

.gf-qa__item { margin-bottom: 14px; }
.gf-qa__item:last-of-type { margin-bottom: 6px; }

.gf-qa__label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--gf-ink);
  line-height: 1.45;
  margin-bottom: 9px;
}

.gf-qa__opts { display: flex; flex-wrap: wrap; gap: 8px; }

.gf-qa__opt {
  font-size: 13px;
  font-weight: 500;
  color: var(--gf-navy);
  padding: 7px 14px;
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: var(--radius-full, 9999px);
  cursor: pointer;
  transition: var(--transition-fast, 0.15s ease);
}
.gf-qa__opt:hover:not(:disabled) { color: #fff; background: var(--gf-navy); border-color: var(--gf-navy); }
.gf-qa__opt:disabled { opacity: 0.5; cursor: default; }

.gf-qa__hint {
  font-size: 11.5px;
  color: var(--gf-faint);
  margin-top: 4px;
}

/* ============================================================
   정밀판정(program_verdict) — §4 "자세히 보기" 응답 카드
   ============================================================ */
.gf-verdict { display: flex; flex-direction: column; }
.gf-verdict__head { margin-bottom: 4px; }

.gf-verdict__badge {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.01em;
  padding: 4px 12px;
  border-radius: var(--radius-full, 9999px);
  margin-bottom: 10px;
}
.gf-verdict__badge--ok    { color: var(--gf-ok); background: var(--gf-ok-bg); }
.gf-verdict__badge--warn  { color: var(--gf-warn-ink); background: var(--gf-warn-bg); }
.gf-verdict__badge--miss  { color: var(--gf-danger); background: var(--gf-danger-bg); }
.gf-verdict__badge--muted { color: var(--gf-muted); background: rgba(19, 49, 79, 0.07); }

.gf-verdict__title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--gf-ink);
  line-height: 1.4;
  margin: 0;
}
.gf-verdict__meta { font-size: 12.5px; color: var(--gf-muted); margin-top: 4px; }

.gf-verdict__sec {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--gf-line);
}
.gf-verdict__sec-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--gf-navy-soft);
  margin: 0 0 10px;
}
.gf-verdict__sec-sub { font-size: 12px; color: var(--gf-muted); margin: -6px 0 10px; line-height: 1.5; }

.gf-verdict__chips { display: flex; flex-wrap: wrap; gap: 7px; }
.gf-verdict__chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 11px;
  border-radius: var(--radius-full, 9999px);
}
.gf-verdict__chip--ok { color: var(--gf-ok); background: var(--gf-ok-bg); }
.gf-verdict__chip-ic { display: inline-flex; }
.gf-verdict__chip-ic svg { width: 11px; height: 11px; }

.gf-verdict__fails { display: flex; flex-direction: column; gap: 12px; }
.gf-verdict__fail { display: flex; flex-direction: column; gap: 4px; }
.gf-verdict__fail-label { font-size: 13px; font-weight: 600; color: var(--gf-danger); }
.gf-verdict__fail-text { font-size: 12px; line-height: 1.55; color: var(--gf-navy-soft); }

/* self-attest 체크 — 실제 input 은 투명 오버레이, box 가 시각 표시 */
.gf-verdict__attest { display: flex; flex-direction: column; gap: 8px; }
.gf-verdict__attest-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 11px;
  border: 1px solid var(--gf-line);
  border-radius: var(--radius-md, 8px);
  cursor: pointer;
  transition: var(--transition-fast, 0.15s ease);
}
.gf-verdict__attest-row:hover { border-color: var(--gf-line-strong); }
.gf-verdict__attest-row.is-on { border-color: var(--gf-ok); background: var(--gf-ok-bg); }
.gf-verdict__attest-cb { position: absolute; inset: 0; margin: 0; opacity: 0; cursor: pointer; }
.gf-verdict__attest-box {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--gf-line-strong);
  border-radius: 5px;
  color: #fff;
}
.gf-verdict__attest-row.is-on .gf-verdict__attest-box { background: var(--gf-ok); border-color: var(--gf-ok); }
.gf-verdict__attest-box svg { width: 11px; height: 11px; }
.gf-verdict__attest-label { font-size: 13px; font-weight: 500; color: var(--gf-ink); }

.gf-verdict__q { margin-bottom: 12px; }
.gf-verdict__q:last-child { margin-bottom: 0; }
.gf-verdict__q-label { font-size: 13px; font-weight: 600; color: var(--gf-ink); margin-bottom: 8px; line-height: 1.45; }
.gf-verdict__q-opts { display: flex; flex-wrap: wrap; gap: 7px; }
.gf-verdict__q-opt {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--gf-navy);
  padding: 6px 13px;
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: var(--radius-full, 9999px);
  cursor: pointer;
  transition: var(--transition-fast, 0.15s ease);
}
.gf-verdict__q-opt:hover:not(:disabled),
.gf-verdict__q-opt.is-on { color: #fff; background: var(--gf-navy); border-color: var(--gf-navy); }
.gf-verdict__q-opt:disabled { opacity: 0.5; cursor: default; }

.gf-verdict__blockers { display: flex; flex-direction: column; gap: 10px; }
.gf-verdict__blocker {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 12px;
  background: rgba(19, 49, 79, 0.04);
  border-radius: var(--radius-md, 8px);
}
.gf-verdict__blocker-reason { font-size: 12.5px; font-weight: 600; color: var(--gf-navy-soft); }
.gf-verdict__blocker-text { font-size: 12px; line-height: 1.55; color: var(--gf-muted); }

.gf-verdict__note { margin-top: 16px; font-size: 12.5px; line-height: 1.6; color: var(--gf-muted); }

.gf-verdict__actions { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 20px; }
.gf-verdict__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: var(--radius-md, 8px);
  cursor: pointer;
  text-decoration: none;
  border: 1px solid transparent;
  transition: var(--transition-fast, 0.15s ease);
}
.gf-verdict__btn--primary { color: #fff; background: var(--gf-navy); }
.gf-verdict__btn--primary:hover:not(:disabled) { background: var(--gf-ink); }
.gf-verdict__btn--primary:disabled { opacity: 0.45; cursor: default; }
.gf-verdict__btn--ghost { color: var(--gf-navy); background: #fff; border-color: var(--gf-line-strong); }
.gf-verdict__btn--ghost:hover { background: #f2f5f8; border-color: var(--gf-navy); }

.gf-verdict__foot {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--gf-line);
  font-size: 11.5px;
  color: var(--gf-muted);
}

/* ============================================================
   신청서 초안(application_draft) — §6 고정 5섹션 점증 doc
   ============================================================ */
.gf-draft { display: flex; flex-direction: column; }
.gf-draft__head { margin-bottom: 14px; }
.gf-draft__title { font-size: 16px; font-weight: 700; letter-spacing: -0.01em; color: var(--gf-ink); line-height: 1.4; margin: 0; }
.gf-draft__meta { font-size: 12.5px; color: var(--gf-muted); margin-top: 4px; }

.gf-draft__progress { margin-bottom: 4px; }
.gf-draft__progress-head { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 6px; }
.gf-draft__progress-label { font-size: 12px; font-weight: 600; color: var(--gf-navy-soft); }
.gf-draft__progress-count { font-size: 12px; font-weight: 700; color: var(--gf-navy); font-variant-numeric: tabular-nums; }
.gf-draft__progress-bar { height: 6px; border-radius: var(--radius-full, 9999px); background: rgba(19, 49, 79, 0.10); overflow: hidden; }
.gf-draft__progress-fill { display: block; height: 100%; border-radius: inherit; background: var(--gf-navy); transition: width 0.4s ease; }

.gf-draft__hint { font-size: 12px; color: var(--gf-muted); line-height: 1.5; margin: 10px 0 4px; }

.gf-draft__sections {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 14px;
  background: var(--gf-line);
  border: 1px solid var(--gf-line);
  border-radius: var(--radius-lg, 8px);
  overflow: hidden;
}
.gf-draft__sec { background: #fff; padding: 14px; }
.gf-draft__sec--stub { background: #fafafb; }
.gf-draft__sec-head { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 7px; }
.gf-draft__sec-label { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }
.gf-draft__sec-status {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: var(--radius-full, 9999px);
  letter-spacing: -0.01em;
}
.gf-draft__sec-status--done { color: var(--gf-ok); background: var(--gf-ok-bg); }
.gf-draft__sec-status--pending { color: var(--gf-faint); background: rgba(19, 49, 79, 0.06); }
.gf-draft__sec-status--stub { color: var(--gf-warn-ink); background: var(--gf-warn-bg); }
.gf-draft__sec-body { font-size: 12.5px; line-height: 1.6; color: var(--gf-navy-soft); margin: 0; white-space: pre-wrap; }
.gf-draft__sec-body--stub { color: var(--gf-muted); font-style: italic; }
.gf-draft__sec-body--empty { color: var(--gf-faint); }

.gf-draft__complete {
  margin-top: 14px;
  padding: 12px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gf-ok);
  background: var(--gf-ok-bg);
  border-radius: var(--radius-md, 8px);
  line-height: 1.5;
}
.gf-draft__disclaimer { margin-top: 12px; font-size: 11.5px; line-height: 1.6; color: var(--gf-muted); }
.gf-draft__foot { margin-top: 10px; font-size: 11.5px; color: var(--gf-faint); }

/* 에이전트 타이핑 인디케이터 */
.gf-msg__text--typing {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}
.gf-msg__text--typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--gf-faint);
  animation: gfTyping 1.2s infinite ease-in-out;
}
.gf-msg__text--typing span:nth-child(2) { animation-delay: 0.15s; }
.gf-msg__text--typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes gfTyping {
  0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-3px); }
}

/* SSE 진행 문장(스피너 + 노드별 label) — 한 줄, 텍스트만 교체 */
.gf-msg__progress {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  padding: 11px 15px;
  background: #fff;
  border: 1px solid var(--gf-line);
  border-radius: 12px;
  font-size: 14px;
  color: var(--gf-ink);
}

.gf-msg__spinner {
  flex: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2.5px solid var(--gf-line-strong);
  border-top-color: var(--gf-navy);
  animation: gfSpin 0.7s linear infinite;
}

@keyframes gfSpin {
  to { transform: rotate(360deg); }
}

.gf-msg__progress-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 에이전트 버블 마크다운 */
.gf-msg__md { line-height: 1.6; }
.gf-msg__md > :first-child { margin-top: 0; }
.gf-msg__md > :last-child { margin-bottom: 0; }
.gf-msg__md p { margin: 0 0 8px; }
.gf-msg__md ol,
.gf-msg__md ul { margin: 6px 0 10px; padding-left: 20px; }
.gf-msg__md li { margin: 3px 0; }
.gf-msg__md h1,
.gf-msg__md h2,
.gf-msg__md h3,
.gf-msg__md h4 { font-size: 14px; font-weight: 700; margin: 14px 0 7px; color: var(--gf-ink); }
.gf-msg__md strong { font-weight: 700; color: var(--gf-ink); }
.gf-msg__md a { color: var(--gf-navy); text-decoration: underline; }
.gf-msg__md hr { border: none; border-top: 1px solid var(--gf-line); margin: 14px 0; }
.gf-msg__md code {
  font-size: 0.9em;
  padding: 1px 5px;
  border-radius: var(--radius-sm, 4px);
  background: rgba(19, 49, 79, 0.06);
}
.gf-msg__md pre {
  background: var(--gf-ink);
  color: #e7dcc6;
  padding: 12px 14px;
  border-radius: var(--radius-md, 6px);
  overflow-x: auto;
  margin: 8px 0;
}
.gf-msg__md pre code { background: none; padding: 0; color: inherit; }
.gf-msg__md table { border-collapse: collapse; margin: 8px 0; font-size: 12.5px; }
.gf-msg__md th,
.gf-msg__md td { border: 1px solid var(--gf-line); padding: 5px 9px; text-align: left; }

/* 매칭 결과 행 — 클릭 가능(공고 상세로 이동) */
.gf-match__row--click { cursor: pointer; transition: background var(--transition-fast, 0.15s ease); }
.gf-match__row--click:hover { background: var(--gf-ok-bg); }
.gf-match__row--warn.gf-match__row--click:hover { background: var(--gf-warn-bg); }
.gf-match__row--miss.gf-match__row--click:hover { background: rgba(14, 27, 43, 0.04); }
.gf-match__row--click:focus-visible { outline: 2px solid var(--gf-navy); outline-offset: -2px; }

/* ============================================================
   공고 상세(GET /programs/{id}) — 패널 상세 뷰
   ============================================================ */
.gf-pd { display: flex; flex-direction: column; }

.gf-pd__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gf-navy);
  padding: 6px 10px 6px 2px;
  margin-bottom: 14px;
  background: none;
  border: none;
  cursor: pointer;
}
.gf-pd__back:hover { color: var(--gf-ink); }
.gf-pd__back span { font-size: 15px; }

.gf-pd__state { font-size: 13px; color: var(--gf-muted); padding: 24px 4px; text-align: center; }
.gf-pd__state--err { color: var(--rust, #a8412a); }

.gf-pd__title {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.35;
  color: var(--gf-ink);
}

.gf-pd__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: var(--gf-muted);
  margin-top: 8px;
}
.gf-pd__status {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: var(--radius-full, 9999px);
  color: var(--gf-navy);
  background: rgba(19, 49, 79, 0.08);
}
.gf-pd__dday { font-size: 12px; font-weight: 700; color: var(--gf-navy); }

.gf-pd__summary {
  font-size: 13px;
  line-height: 1.6;
  color: var(--gf-navy-soft);
  margin-top: 14px;
  padding: 13px 15px;
  background: var(--gf-ok-bg, rgba(47, 111, 78, 0.06));
  border-radius: var(--radius-md, 6px);
}

/* 공고 상세 → 정밀판정 CTA (§4 — 내용 확인 후 명시적 요청) */
.gf-pd__verdict {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  padding: 14px 16px;
  background: rgba(19, 49, 79, 0.05);
  border: 1px solid var(--gf-line);
  border-radius: var(--radius-lg, 8px);
}
.gf-pd__verdict-text { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.gf-pd__verdict-text strong { font-size: 13.5px; font-weight: 700; color: var(--gf-ink); letter-spacing: -0.01em; }
.gf-pd__verdict-text span { font-size: 12px; color: var(--gf-muted); line-height: 1.5; }
.gf-pd__verdict-btn {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: var(--gf-navy);
  border: 1px solid var(--gf-navy);
  border-radius: var(--radius-md, 8px);
  padding: 9px 16px;
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-fast, 0.15s ease);
}
.gf-pd__verdict-btn:hover:not(:disabled) { background: var(--gf-ink); border-color: var(--gf-ink); }
.gf-pd__verdict-btn:disabled { opacity: 0.45; cursor: default; }

@media (max-width: 720px) {
  .gf-pd__verdict { flex-direction: column; align-items: stretch; }
  .gf-pd__verdict-btn { width: 100%; }
}

.gf-pd__sec { margin-top: 24px; }
.gf-pd__sec-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--gf-ink);
  padding-bottom: 8px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--gf-line);
}

.gf-pd__support {
  padding: 11px 0;
  border-bottom: 1px solid var(--gf-line);
}
.gf-pd__support:last-child { border-bottom: none; }
.gf-pd__support-head { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
.gf-pd__support-item { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }
.gf-pd__support-amount { font-size: 13px; font-weight: 700; color: var(--gf-ok, #2f6f4e); white-space: nowrap; }
.gf-pd__support-detail { font-size: 12.5px; color: var(--gf-muted); line-height: 1.55; margin-top: 5px; }
.gf-pd__support-cond { font-size: 12px; color: var(--gf-faint); margin-top: 5px; }

.gf-pd__crit {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 0;
  border-bottom: 1px solid var(--gf-line);
}
.gf-pd__crit:last-child { border-bottom: none; }
.gf-pd__crit-tag {
  align-self: flex-start;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: var(--radius-full, 9999px);
  border: 1px solid var(--gf-line-strong);
  color: var(--gf-muted);
}
.gf-pd__crit-tag--hard { color: var(--rust, #a8412a); border-color: rgba(168, 65, 42, 0.35); }
.gf-pd__crit-tag--soft { color: var(--gf-brass); border-color: rgba(154, 123, 79, 0.4); }
.gf-pd__crit-text { font-size: 12.5px; line-height: 1.55; color: var(--gf-navy-soft); }

.gf-pd__file {
  display: block;
  font-size: 12.5px;
  color: var(--gf-navy);
  text-decoration: none;
  padding: 7px 0;
  border-bottom: 1px solid var(--gf-line);
}
.gf-pd__file:last-of-type { border-bottom: none; }
.gf-pd__file:hover { text-decoration: underline; }
.gf-pd__file::before { content: "↧ "; color: var(--gf-faint); }

/* 공고문 인라인 미리보기 (Google Docs Viewer iframe) */
.gf-pd__preview {
  position: relative;
  height: min(760px, 78vh);
  background: #e9e7e2;
  border: 1px solid var(--gf-line);
  border-radius: var(--radius-md, 6px);
  overflow: hidden;
}
.gf-pd__preview-frame {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
}
.gf-pd__preview-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12.5px;
  color: var(--gf-muted);
  pointer-events: none;
}
.gf-pd__preview-note {
  margin: 8px 0 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--gf-faint);
}

.gf-pd__doc {
  font-size: 12.5px;
  line-height: 1.7;
  color: var(--gf-muted);
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 360px;
  overflow-y: auto;
  padding: 13px 15px;
  background: rgba(19, 49, 79, 0.03);
  border: 1px solid var(--gf-line);
  border-radius: var(--radius-md, 6px);
}

.gf-pd__source {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: var(--gf-navy);
  text-decoration: none;
  margin-top: 22px;
}
.gf-pd__source:hover { text-decoration: underline; }

/* ========================================================================
   모바일 (≤720px) — AgentShowcase [2단계].
   히어로/번호 칼럼을 좁은 화면에 맞춰 축소. 인덱스는 이미 세로 리스트라 구조는 유지.
   ======================================================================== */
@media (max-width: 720px) {
  /* ① 콘텐츠 패딩 leak 차단 — showcase 비-미디어 .prompt__content(56/60)가
     Agent.css 모바일 패딩(16/14)을 덮어써 본문이 ~220px 로 짜부되던 문제.
     같은 파일 뒤쪽 + 미디어 매칭이라 이 규칙이 이긴다. */
  .gf-showcase-page .prompt__content { padding: 18px 16px 56px; }

  /* ② 마스트헤드 */
  .gf-showcase-page .gf-showcase__headline { font-size: 26px; margin-top: 14px; }
  .gf-showcase-page .gf-showcase__deck { font-size: 13.5px; margin-top: 14px; }
  .gf-showcase-page .gf-showcase__rule { margin-top: 26px; }

  /* ③ 인덱스 행 — 번호 축소 + 화살표 숨김(행 전체 탭 가능), 번호|본문 2열 */
  .gf-showcase-page .gf-item {
    grid-template-columns: 34px 1fr;
    gap: 6px 10px;
    padding: 18px 2px 16px;
  }
  .gf-showcase-page .gf-item__num { font-size: 22px; }
  .gf-showcase-page .gf-item__arrow { display: none; }
  .gf-showcase-page .gf-item__name { font-size: 18px; }
  /* 공식 배지는 이름 아래 줄로(인라인 줄바꿈 깨짐 방지) */
  .gf-showcase-page .gf-item__official { display: block; margin: 5px 0 0; }
  .gf-showcase-page .gf-item__desc { font-size: 13px; margin-top: 8px; }
  .gf-showcase-page .gf-item__meta { margin-top: 12px; flex-wrap: wrap; gap: 4px 8px; }
}

/* ============================================================
   리서치(idea-research) — 입구 카드 (.gf-ric)
   필수 1 + ★ 2(확신·목표) + 선택. 네이비 톤 단일 카드.
   ============================================================ */
.gf-ric {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: grid;
  place-items: center;
  padding: 24px;
}
.gf-ric__scrim {
  position: absolute;
  inset: 0;
  background: rgba(8, 16, 28, 0.46);
  backdrop-filter: blur(2px);
}
.gf-ric__card {
  position: relative;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 30px 60px -28px rgba(8, 16, 28, 0.55);
  overflow: hidden;
  animation: gfRise 0.5s cubic-bezier(0.2, 0.7, 0.2, 1);
}
.gf-ric__head {
  flex: none;
  padding: 22px 24px 16px;
  background: var(--gf-navy);
  color: #fff;
}
.gf-ric__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.62);
}
.gf-ric__title {
  margin: 6px 0 4px;
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -0.02em;
}
.gf-ric__sub {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
}
.gf-ric__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px 6px;
}
.gf-ric__fld { margin-bottom: 16px; }
.gf-ric__lbl {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--gf-ink);
  margin-bottom: 7px;
}
.gf-ric__tag {
  font-size: 10.5px;
  font-weight: 600;
  color: var(--gf-muted);
  background: rgba(14, 27, 43, 0.06);
  border-radius: 999px;
  padding: 2px 8px;
}
.gf-ric__tag--req { color: #fff; background: var(--gf-navy); }
.gf-ric__ctrl {
  width: 100%;
  font: inherit;
  font-size: 14px;
  color: var(--gf-ink);
  background: #f7f9fc;
  border: 1.5px solid var(--gf-line-strong);
  border-radius: 11px;
  padding: 11px 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.gf-ric__ctrl::placeholder { color: var(--gf-faint); }
.gf-ric__ctrl:focus {
  outline: none;
  border-color: var(--gf-navy);
  background: #fff;
}
.gf-ric__ctrl--err { border-color: #b4452f; background: #fdf3f1; }
.gf-ric__area { resize: vertical; min-height: 58px; line-height: 1.5; }
.gf-ric__err { margin: 6px 0 0; font-size: 11.5px; color: #b4452f; }

/* ★ 창업자 직접 입력 — 강조 필드 */
.gf-ric__fld--star {
  background: rgba(19, 49, 79, 0.045);
  border: 1px solid rgba(19, 49, 79, 0.12);
  border-radius: 13px;
  padding: 13px 14px;
}
.gf-ric__fld--star .gf-ric__ctrl { background: #fff; }
.gf-ric__star {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  background: var(--gf-navy);
  border-radius: 5px;
  padding: 2px 6px;
}
.gf-ric__micro {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 7px 0 0;
  font-size: 11px;
  color: var(--gf-navy-soft);
}
.gf-ric__micro::before {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}
.gf-ric__micro--faint { color: var(--gf-faint); }

/* 목표 규모 segmented */
.gf-ric__seg {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
}
.gf-ric__seg-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 10px 6px;
  font: inherit;
  background: #fff;
  border: 1.5px solid var(--gf-line-strong);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.gf-ric__seg-btn:hover { border-color: var(--gf-navy-soft); }
.gf-ric__seg-btn.is-on {
  background: var(--gf-navy);
  border-color: var(--gf-navy);
  box-shadow: 0 6px 14px -8px rgba(19, 49, 79, 0.7);
}
.gf-ric__seg-main { font-size: 13px; font-weight: 700; color: var(--gf-ink); }
.gf-ric__seg-hint { font-size: 10px; color: var(--gf-muted); }
.gf-ric__seg-btn.is-on .gf-ric__seg-main,
.gf-ric__seg-btn.is-on .gf-ric__seg-hint { color: #fff; }
.gf-ric__seg-btn.is-on .gf-ric__seg-hint { color: rgba(255, 255, 255, 0.72); }

.gf-ric__optbar {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 18px 0 14px;
  padding-top: 14px;
  border-top: 1px dashed var(--gf-line-strong);
}
.gf-ric__optbar-ttl { font-size: 12px; font-weight: 600; color: var(--gf-muted); }
.gf-ric__row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.gf-ric__row2 .gf-ric__fld { margin-bottom: 0; }

.gf-ric__foot {
  flex: none;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 14px 24px 6px;
  border-top: 1px solid var(--gf-line);
}
.gf-ric__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 42px;
  padding: 0 20px;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  border-radius: 11px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.gf-ric__btn--ghost { color: var(--gf-muted); background: none; border-color: var(--gf-line-strong); }
.gf-ric__btn--ghost:hover { color: var(--gf-ink); border-color: var(--gf-navy-soft); }
.gf-ric__btn--primary { color: #fff; background: var(--gf-navy); box-shadow: 0 12px 24px -12px rgba(19, 49, 79, 0.8); }
.gf-ric__btn--primary:hover { background: var(--gf-ink); }
.gf-ric__btn:disabled { opacity: 0.55; cursor: default; }
.gf-ric__note {
  margin: 0;
  padding: 6px 24px 18px;
  font-size: 11px;
  color: var(--gf-faint);
  text-align: center;
}

/* ============================================================
   리서치 — 검증 리포트 패널 (.gf-rp, 우측 읽기 전용)
   · 툴바는 입력창 위(.gf-work__rtoolbar)
   · 버튼/질문 결과는 채팅 인라인(.gf-msg__rart)
   ============================================================ */
.gf-work__panel--research {
  /* 폭은 매칭 결과 패널(.gf-work__panel)과 동일 — 기본 880px + 동일 반응형(620/460) 상속 */
  animation: gfFadeIn 0.32s ease;
}
.gf-rp { display: block; }
.gf-rp__placeholder { font-size: 13px; color: var(--gf-muted); }
.gf-rp__banner {
  margin: 0 0 12px;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--gf-warn);
  background: var(--gf-warn-bg);
  border: 1px solid rgba(154, 123, 79, 0.3);
  border-radius: 9px;
}
.gf-rp__steps { margin: 6px 0 0; padding-left: 18px; font-size: 13px; color: var(--gf-ink); line-height: 1.6; }
.gf-rp__steps li { margin: 4px 0; }

/* 리포트 본문 */
.gf-rp__title {
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.35;
  color: var(--gf-ink);
}
.gf-rp__verdict {
  margin-bottom: 14px;
  padding: 12px 13px;
  background: var(--gf-warn-bg);
  border: 1px solid rgba(154, 123, 79, 0.3);
  border-radius: 11px;
}
.gf-rp__verdict-tag {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--gf-warn);
  margin-bottom: 5px;
}
.gf-rp__verdict-r { display: block; font-size: 13px; line-height: 1.55; color: var(--gf-ink); }
.gf-rp__sec { padding: 10px 0; border-top: 1px solid var(--gf-line); font-size: 13px; color: var(--gf-muted); line-height: 1.6; }
.gf-rp__sec:first-of-type { border-top: none; }
.gf-rp__sec-t { display: block; font-size: 12.5px; font-weight: 700; color: var(--gf-ink); margin-bottom: 3px; }
.gf-rp__sec-b { color: var(--gf-muted); }
.gf-rp__critic {
  margin-top: 12px;
  padding: 12px 14px;
  background: rgba(19, 49, 79, 0.04);
  border: 1px solid rgba(19, 49, 79, 0.14);
  border-radius: 11px;
}
.gf-rp__critic-t { font-size: 11.5px; font-weight: 700; color: var(--gf-navy); margin-bottom: 6px; }
.gf-rp__critic-list { margin: 0; padding-left: 17px; font-size: 12.5px; color: var(--gf-ink); line-height: 1.6; }
.gf-rp__critic-list li { margin: 3px 0; }
.gf-rp__gov { margin-top: 12px; padding-top: 10px; border-top: 1px solid var(--gf-line); }
.gf-rp__kv { display: flex; flex-direction: column; gap: 2px; }
.gf-rp__kv-row { display: flex; gap: 10px; padding: 4px 0; font-size: 12.5px; }
.gf-rp__kv-k { min-width: 92px; color: var(--gf-faint); }
.gf-rp__kv-v { color: var(--gf-ink); font-weight: 600; }
.gf-rp__empty { font-size: 12px; color: var(--gf-faint); font-style: italic; }
.gf-rp__md { font-size: 13px; line-height: 1.62; color: var(--gf-ink); }
.gf-rp__md > :first-child { margin-top: 0; }
.gf-rp__md > :last-child { margin-bottom: 0; }
.gf-rp__md h1, .gf-rp__md h2, .gf-rp__md h3, .gf-rp__md h4 { font-size: 13.5px; font-weight: 700; margin: 12px 0 5px; color: var(--gf-ink); }
.gf-rp__md p { margin: 6px 0; }
.gf-rp__md ul, .gf-rp__md ol { margin: 6px 0; padding-left: 18px; }
.gf-rp__md code { font-size: 12px; background: rgba(14, 27, 43, 0.06); padding: 1px 5px; border-radius: 5px; }

/* 입력창 위 액션 바 (.gf-work__rtoolbar) */
.gf-work__rtoolbar {
  margin-bottom: 10px;
  padding: 10px 12px;
  background: rgba(19, 49, 79, 0.04);
  border: 1px solid var(--gf-line);
  border-radius: 12px;
}
.gf-work__rtoolbar-h {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--gf-navy);
  margin-bottom: 8px;
}
.gf-work__rtoolbar-row { display: flex; flex-wrap: wrap; gap: 6px; }

/* 액션 버튼(입력창 위 툴바) */
.gf-rp__tool {
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--gf-navy);
  background: #fff;
  border: 1px solid var(--gf-line-strong);
  border-radius: 8px;
  padding: 6px 11px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.gf-rp__tool:hover { border-color: var(--gf-navy); background: rgba(19, 49, 79, 0.05); }
.gf-rp__tool--free { color: var(--gf-brass); border-color: rgba(154, 123, 79, 0.4); background: var(--gf-warn-bg); }
.gf-rp__tool--free:hover { border-color: var(--gf-brass); }
.gf-rp__tool:disabled { opacity: 0.45; cursor: default; }
.gf-rp__tool:disabled:hover { border-color: var(--gf-line-strong); background: #fff; }
.gf-rp__tool--free:disabled:hover { background: var(--gf-warn-bg); border-color: rgba(154, 123, 79, 0.4); }

/* 채팅 버블 안 인라인 결과 카드 (.gf-msg__rart) */
.gf-msg__rart {
  margin-top: 10px;
  border: 1px solid var(--gf-line);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.gf-msg__rart-h {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 13px;
  font-size: 12px;
  font-weight: 700;
  color: var(--gf-ink);
  background: rgba(19, 49, 79, 0.04);
  border-bottom: 1px solid var(--gf-line);
}
.gf-msg__rart-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--gf-navy); flex: none; }
.gf-msg__rart-b { padding: 12px 13px; font-size: 12.5px; color: var(--gf-muted); }
`, "",{"version":3,"sources":["webpack://./src/css/AgentShowcase.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE,iBAAiB,aAAa,uBAAuB;EACrD,kBAAkB,YAAY,YAAY;EAC1C,uBAAuB,OAAO,WAAW;EACzC,mBAAmB,WAAW,UAAU;EACxC,mBAAmB,WAAW,WAAW;EACzC,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB,WAAW,mBAAmB;EACjD,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;AACzB;;AAEA;;iEAEiE;AACjE;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,uCAAuC;EACvC,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,8DAA8D;EAC9D,iCAAiC;AACnC;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,mFAAmF;AACrF;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,WAAW;AACX,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;;AAEhD;EACE,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE;aACW,eAAe,EAAE,UAAU,EAAE,eAAe,EAAE;AAC3D;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,UAAU;EACV,8DAA8D;AAChE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,QAAQ;AACR;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,0BAA0B,2BAA2B,EAAE;AACvD,wBAAwB,0BAA0B,EAAE;AACpD,yBAAyB,mBAAmB,EAAE;AAC9C,2BAA2B,+BAA+B,EAAE;;AAE5D;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;;iEAGiE;;AAEjE,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;EACzC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;AACA,2CAA2C,cAAc,EAAE;;AAE3D;sDACsD;AACtD;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA,iCAAiC,oBAAoB,EAAE,kCAAkC,EAAE;AAC3F,+BAA+B;AAC/B;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA,UAAU;AACV;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,QAAQ;AACR;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,OAAO,QAAQ,EAAE,UAAU,EAAE;EAC7B,KAAK,YAAY,EAAE,UAAU,EAAE;AACjC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,YAAY,EAAE;EAChC,uBAAuB,OAAO,QAAQ,EAAE,UAAU,EAAE,EAAE,KAAK,YAAY,EAAE,UAAU,EAAE,EAAE;AACzF;;AAEA;EACE,kBAAkB,YAAY,EAAE;EAChC,uBAAuB,OAAO,QAAQ,EAAE,UAAU,EAAE,EAAE,KAAK,YAAY,EAAE,UAAU,EAAE,EAAE;AACzF;;AAEA;;iEAEiE;;AAEjE,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,wBAAwB,eAAe,EAAE,sBAAsB,EAAE;AACjE,mBAAmB,iBAAiB,EAAE,sBAAsB,EAAE;;AAE9D,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC7E,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;AAChF;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,WAAW;AACX,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAEnF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,wDAAwD;AAC1D;;AAEA,wBAAwB,4BAA4B,EAAE;AACtD,wBAAwB,eAAe,EAAE,4BAA4B,EAAE;AACvE,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACxE,wBAAwB,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AACnF,uBAAuB,eAAe,EAAE,sBAAsB,EAAE;;AAEhE,aAAa;AACb,eAAe,aAAa,EAAE,sBAAsB,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,iCAAiC,oCAAoC,EAAE;AACvE;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,6CAA6C,0BAA0B,EAAE,4BAA4B,EAAE;AACvG,gDAAgD,6BAA6B,EAAE,2BAA2B,EAAE,4CAA4C,EAAE;AAC1J;kDACkD,oBAAoB,EAAE;AACxE,sBAAsB,SAAO,EAAE;AAC/B,sBAAsB,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC7F,kDAAkD,sBAAsB,EAAE;;AAE1E,qBAAqB,WAAW,UAAU,EAAE,EAAE,MAAM,YAAY,EAAE,EAAE;;AAEpE,uBAAuB;AACvB,SAAS,aAAa,EAAE,sBAAsB,EAAE;AAChD;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,iBAAiB;AACnB;AACA,0BAA0B,oCAAoC,EAAE;AAChE,YAAY,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,sBAAsB,EAAE;AACtG,YAAY,SAAO,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;;AAE7D,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;AACA,yBAAyB,aAAa,EAAE;AACxC,aAAa,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAErF,YAAY;AACZ,cAAc,aAAa,EAAE,sBAAsB,EAAE;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;AACA,yBAAyB,8CAA8C,EAAE;AACzE;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,cAAc;AACd,YAAY,aAAa,EAAE,sBAAsB,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uCAAuC;EACvC,iBAAiB;EACjB,sBAAsB;AACxB;AACA,6BAA6B,oCAAoC,EAAE;AACnE;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA,sCAAsC,0BAA0B,EAAE,4BAA4B,EAAE;AAChG,wCAAwC,oBAAoB,EAAE;AAC9D,mBAAmB,SAAO,EAAE;;AAE5B,aAAa;AACb,eAAe,aAAa,EAAE,sBAAsB,EAAE;AACtD,oBAAoB,aAAa,EAAE,SAAS,EAAE;AAC9C;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA,qBAAqB,UAAU,EAAE,kBAAkB,EAAE,WAAW,EAAE,aAAa,EAAE,uBAAuB,EAAE;AAC1G;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;AACA,2DAA2D,QAAQ,EAAE;AACrE,0DAA0D,YAAY,EAAE,WAAW,EAAE;AACrF;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA,qBAAqB,SAAO,EAAE,iBAAiB,EAAE;AACjD,sBAAsB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AACjG,oBAAoB,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAEhG,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;AACA,mCAAmC,cAAc,EAAE,kCAAkC,EAAE;AACvF,wCAAwC,sBAAsB,EAAE,oCAAoC,EAAE;AACtG,mBAAmB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC7F,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACjH,iBAAiB,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAEvE,6CAA6C;AAC7C;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,2DAA2D;AAC7D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;iEAGiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kCAAkC;EAClC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,gBAAgB;AAChB,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;AACA,6BAA6B,iCAAiC,EAAE;AAChE,2BAA2B,4BAA4B,EAAE,kCAAkC,EAAE;AAC7F;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;AACA,+BAA+B,0BAA0B,EAAE,4BAA4B,EAAE;AACzF,6BAA6B,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;;AAE3G;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa,UAAU,EAAE;EACzB,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,gBAAgB,EAAE;EACtF,mBAAmB,oBAAoB,EAAE;EACzC,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,kBAAkB,EAAE;EACvC,mBAAmB,0BAA0B,EAAE;EAC/C,kBAAkB,eAAe,EAAE;EACnC,0BAA0B,aAAa,EAAE;AAC3C;;AAEA;;;iEAGiE;AACjE;EACE,gBAAgB,aAAa,qBAAqB;EAClD,mCAAmC;EACnC,0BAA0B,GAAG,cAAc;EAC3C,sCAAsC;EACtC,sBAAsB,OAAO,iCAAiC;EAC9D,oBAAoB,SAAS,oCAAoC;EACjE,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,8CAA8C;AAChD;AACA,uBAAuB,oBAAoB,EAAE;;AAE7C;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,uBAAuB,oBAAoB,EAAE,mCAAmC,EAAE;AAClF,iCAAiC,mBAAmB,EAAE,iCAAiC,EAAE;AACzF,sDAAsD,WAAW,EAAE,wBAAwB,EAAE;AAC7F;8BAC8B,qBAAqB,EAAE,mCAAmC,EAAE;AAC1F,mDAAmD,WAAW,EAAE,0BAA0B,EAAE;AAC5F,6BAA6B,oBAAoB,EAAE,0CAA0C,EAAE;AAC/F,kDAAkD,WAAW,EAAE,+BAA+B,EAAE;;AAEhG,kBAAkB,aAAa,EAAE,sBAAsB,EAAE;;AAEzD;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe,eAAe,oCAAoC;EAClE,uCAAuC;EACvC,kBAAkB;AACpB;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD;uCACuC;;AAEvC,kBAAkB,SAAO,EAAE,YAAY,EAAE;;AAEzC;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;EACvB,mBAAmB;AACrB;AACA,uBAAuB,yBAAyB,EAAE,6BAA6B,EAAE;AACjF,uBAAuB,0BAA0B,EAAE,kCAAkC,EAAE;;AAEvF;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;AACA,wBAAwB,0BAA0B,EAAE;;AAEpD,oCAAoC;AACpC;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,kCAAkC;EAClC,sBAAsB;AACxB;AACA,0BAA0B,gBAAgB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE;AACxG,0BAA0B,0BAA0B,EAAE,kCAAkC,EAAE;AAC1F,wBAAwB,qBAAqB,EAAE,kCAAkC,EAAE;AACnF,0BAA0B,uBAAuB,EAAE,+BAA+B,EAAE;AACpF,0BAA0B,gBAAgB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE,6BAA6B,EAAE;;AAEvI,yCAAyC;AACzC;EACE,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,gDAAgD;AAClD;AACA,wCAAwC,aAAa,EAAE;AACvD,8CAA8C,UAAU,EAAE,qBAAqB,EAAE;;AAEjF;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EACjB,sBAAsB,SAAS,sCAAsC;EACrE,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,eAAe,mBAAmB,EAAE;AACpC,4BAA4B,kBAAkB,EAAE;;AAEhD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,eAAe,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAEzD;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,yCAAyC;EACzC,eAAe;EACf,8CAA8C;AAChD;AACA,mCAAmC,WAAW,EAAE,0BAA0B,EAAE,4BAA4B,EAAE;AAC1G,uBAAuB,YAAY,EAAE,eAAe,EAAE;;AAEtD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;iEAEiE;AACjE,cAAc,aAAa,EAAE,sBAAsB,EAAE;AACrD,oBAAoB,kBAAkB,EAAE;;AAExC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;AACrB;AACA,4BAA4B,mBAAmB,EAAE,2BAA2B,EAAE;AAC9E,4BAA4B,yBAAyB,EAAE,6BAA6B,EAAE;AACtF,4BAA4B,uBAAuB,EAAE,+BAA+B,EAAE;AACtF,4BAA4B,sBAAsB,EAAE,kCAAkC,EAAE;;AAExF;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;AACX;AACA,oBAAoB,iBAAiB,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAEhF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,uBAAuB,eAAe,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEvG,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;AACA,wBAAwB,mBAAmB,EAAE,2BAA2B,EAAE;AAC1E,uBAAuB,oBAAoB,EAAE;AAC7C,2BAA2B,WAAW,EAAE,YAAY,EAAE;;AAEtD,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACvE,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACtF,yBAAyB,eAAe,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;;AAEzF,qDAAqD;AACrD,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACvE;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,8CAA8C;AAChD;AACA,gCAAgC,mCAAmC,EAAE;AACrE,gCAAgC,0BAA0B,EAAE,2BAA2B,EAAE;AACzF,yBAAyB,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,eAAe,EAAE;AAC/F;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;AACA,wDAAwD,wBAAwB,EAAE,0BAA0B,EAAE;AAC9G,8BAA8B,WAAW,EAAE,YAAY,EAAE;AACzD,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;;AAErF,iBAAiB,mBAAmB,EAAE;AACtC,4BAA4B,gBAAgB,EAAE;AAC9C,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACvH,sBAAsB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAChE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,yCAAyC;EACzC,eAAe;EACf,8CAA8C;AAChD;AACA;2BAC2B,WAAW,EAAE,0BAA0B,EAAE,4BAA4B,EAAE;AAClG,8BAA8B,YAAY,EAAE,eAAe,EAAE;;AAE7D,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;AACtC;AACA,8BAA8B,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC/F,4BAA4B,eAAe,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAExF,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAEnG,uBAAuB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACnF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,8CAA8C;AAChD;AACA,4BAA4B,WAAW,EAAE,0BAA0B,EAAE;AACrE,iDAAiD,yBAAyB,EAAE;AAC5E,qCAAqC,aAAa,EAAE,eAAe,EAAE;AACrE,0BAA0B,qBAAqB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AACxG,gCAAgC,mBAAmB,EAAE,4BAA4B,EAAE;;AAEnF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE,YAAY,aAAa,EAAE,sBAAsB,EAAE;AACnD,kBAAkB,mBAAmB,EAAE;AACvC,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAClI,kBAAkB,iBAAiB,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE9E,sBAAsB,kBAAkB,EAAE;AAC1C,2BAA2B,aAAa,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AACrH,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC3F,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kCAAkC,EAAE;AAC1H,0BAA0B,WAAW,EAAE,yCAAyC,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;AACxI,2BAA2B,cAAc,EAAE,YAAY,EAAE,sBAAsB,EAAE,0BAA0B,EAAE,2BAA2B,EAAE;;AAE1I,kBAAkB,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEjG;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;AACA,iBAAiB,gBAAgB,EAAE,aAAa,EAAE;AAClD,uBAAuB,mBAAmB,EAAE;AAC5C,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACzH,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAClF;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;AACzB;AACA,8BAA8B,mBAAmB,EAAE,2BAA2B,EAAE;AAChF,iCAAiC,sBAAsB,EAAE,kCAAkC,EAAE;AAC7F,8BAA8B,yBAAyB,EAAE,6BAA6B,EAAE;AACxF,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,SAAS,EAAE,qBAAqB,EAAE;AACzH,4BAA4B,sBAAsB,EAAE,kBAAkB,EAAE;AACxE,6BAA6B,sBAAsB,EAAE;;AAErD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;AAClB;AACA,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACvG,kBAAkB,gBAAgB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAE/E,mBAAmB;AACnB;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,0CAA0C,sBAAsB,EAAE;AAClE,0CAA0C,qBAAqB,EAAE;;AAEjE;EACE,gBAAgB,YAAY,EAAE,wBAAwB,EAAE;EACxD,MAAM,UAAU,EAAE,2BAA2B,EAAE;AACjD;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB,cAAc,gBAAgB,EAAE;AAChC,6BAA6B,aAAa,EAAE;AAC5C,4BAA4B,gBAAgB,EAAE;AAC9C,gBAAgB,eAAe,EAAE;AACjC;iBACiB,kBAAkB,EAAE,kBAAkB,EAAE;AACzD,iBAAiB,aAAa,EAAE;AAChC;;;iBAGiB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AAC9F,qBAAqB,gBAAgB,EAAE,oBAAoB,EAAE;AAC7D,gBAAgB,qBAAqB,EAAE,0BAA0B,EAAE;AACnE,iBAAiB,YAAY,EAAE,oCAAoC,EAAE,cAAc,EAAE;AACrF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;AACf;AACA,uBAAuB,gBAAgB,EAAE,UAAU,EAAE,cAAc,EAAE;AACrE,oBAAoB,yBAAyB,EAAE,aAAa,EAAE,iBAAiB,EAAE;AACjF;iBACiB,gCAAgC,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEvF,+BAA+B;AAC/B,wBAAwB,eAAe,EAAE,yDAAyD,EAAE;AACpG,8BAA8B,2BAA2B,EAAE;AAC3D,kDAAkD,6BAA6B,EAAE;AACjF,kDAAkD,kCAAkC,EAAE;AACtF,sCAAsC,iCAAiC,EAAE,oBAAoB,EAAE;;AAE/F;;iEAEiE;AACjE,SAAS,aAAa,EAAE,sBAAsB,EAAE;;AAEhD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA,qBAAqB,oBAAoB,EAAE;AAC3C,oBAAoB,eAAe,EAAE;;AAErC,gBAAgB,eAAe,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAChG,qBAAqB,2BAA2B,EAAE;;AAElD;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;EACrB,kCAAkC;AACpC;AACA,eAAe,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAEzE;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;AACtC;AACA,uBAAuB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/F,8BAA8B,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,uBAAuB,EAAE;AAClH,4BAA4B,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACvF;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;AACA,2CAA2C,yBAAyB,EAAE,2BAA2B,EAAE;AACnG,+BAA+B,aAAa,EAAE,eAAe,EAAE;;AAE/D;EACE,kBAAkB,sBAAsB,EAAE,oBAAoB,EAAE;EAChE,sBAAsB,WAAW,EAAE;AACrC;;AAEA,cAAc,gBAAgB,EAAE;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;AACA,6BAA6B,mBAAmB,EAAE;AAClD,uBAAuB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACxG,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAClF,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;AAC/G,yBAAyB,iBAAiB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACxG,uBAAuB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uCAAuC;AACzC;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,uCAAuC;EACvC,sBAAsB;AACxB;AACA,yBAAyB,2BAA2B,EAAE,qCAAqC,EAAE;AAC7F,yBAAyB,sBAAsB,EAAE,qCAAqC,EAAE;AACxF,oBAAoB,iBAAiB,EAAE,iBAAiB,EAAE,0BAA0B,EAAE;;AAEtF;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,uCAAuC;AACzC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,qBAAqB,0BAA0B,EAAE;AACjD,uBAAuB,aAAa,EAAE,sBAAsB,EAAE;;AAE9D,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,uBAAuB,0BAA0B,EAAE;;AAEnD;;;6EAG6E;AAC7E;EACE;;qCAEmC;EACnC,qCAAqC,uBAAuB,EAAE;;EAE9D,YAAY;EACZ,2CAA2C,eAAe,EAAE,gBAAgB,EAAE;EAC9E,uCAAuC,iBAAiB,EAAE,gBAAgB,EAAE;EAC5E,uCAAuC,gBAAgB,EAAE;;EAEzD,kDAAkD;EAClD;IACE,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;EACxB;EACA,kCAAkC,eAAe,EAAE;EACnD,oCAAoC,aAAa,EAAE;EACnD,mCAAmC,eAAe,EAAE;EACpD,mCAAmC;EACnC,uCAAuC,cAAc,EAAE,eAAe,EAAE;EACxE,mCAAmC,eAAe,EAAE,eAAe,EAAE;EACrE,mCAAmC,gBAAgB,EAAE,eAAe,EAAE,YAAY,EAAE;AACtF;;AAEA;;;iEAGiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,mDAAmD;EACnD,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;AACA,eAAe,mBAAmB,EAAE;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;AAClB;AACA,oBAAoB,WAAW,EAAE,0BAA0B,EAAE;AAC7D;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,0DAA0D;AAC5D;AACA,6BAA6B,sBAAsB,EAAE;AACrD;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,qBAAqB,qBAAqB,EAAE,mBAAmB,EAAE;AACjE,gBAAgB,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACtE,eAAe,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAEnE,wBAAwB;AACxB;EACE,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;AACA,mCAAmC,gBAAgB,EAAE;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;AACA,wBAAwB,sBAAsB,EAAE;;AAEhD,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA,yBAAyB,iCAAiC,EAAE;AAC5D;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iDAAiD;AACnD;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC7E,oBAAoB,eAAe,EAAE,sBAAsB,EAAE;AAC7D;2CAC2C,WAAW,EAAE;AACxD,2CAA2C,gCAAgC,EAAE;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;AACA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACjF,gBAAgB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC1E,6BAA6B,gBAAgB,EAAE;;AAE/C;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;AAC5B;AACA,sBAAsB,sBAAsB,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AACrG,4BAA4B,oBAAoB,EAAE,iCAAiC,EAAE;AACrF,wBAAwB,WAAW,EAAE,0BAA0B,EAAE,mDAAmD,EAAE;AACtH,8BAA8B,yBAAyB,EAAE;AACzD,wBAAwB,aAAa,EAAE,eAAe,EAAE;AACxD;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;iEAIiE;AACjE;EACE,qEAAqE;EACrE,8BAA8B;AAChC;AACA,SAAS,cAAc,EAAE;AACzB,sBAAsB,eAAe,EAAE,sBAAsB,EAAE;AAC/D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,yCAAyC;EACzC,kBAAkB;AACpB;AACA,gBAAgB,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAC9G,mBAAmB,aAAa,EAAE;;AAElC,WAAW;AACX;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA,oBAAoB,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;AAC9F,cAAc,eAAe,EAAE,oCAAoC,EAAE,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAChI,4BAA4B,gBAAgB,EAAE;AAC9C,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,kBAAkB,EAAE;AAC/G,gBAAgB,sBAAsB,EAAE;AACxC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;AACrB;AACA,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AACnG,sBAAsB,SAAS,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAChH,yBAAyB,aAAa,EAAE;AACxC,cAAc,gBAAgB,EAAE,iBAAiB,EAAE,oCAAoC,EAAE;AACzF,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC9D,iBAAiB,aAAa,EAAE,SAAS,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC9E,eAAe,eAAe,EAAE,sBAAsB,EAAE;AACxD,eAAe,oBAAoB,EAAE,gBAAgB,EAAE;AACvD,gBAAgB,eAAe,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AAC7E,aAAa,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;AACvE,4BAA4B,aAAa,EAAE;AAC3C,2BAA2B,gBAAgB,EAAE;AAC7C,6DAA6D,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;AAC5I,eAAe,aAAa,EAAE;AAC9B,+BAA+B,aAAa,EAAE,kBAAkB,EAAE;AAClE,kBAAkB,eAAe,EAAE,kCAAkC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE7G,oCAAoC;AACpC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;AACA,yBAAyB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAEnE,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;AACA,qBAAqB,4BAA4B,EAAE,kCAAkC,EAAE;AACvF,qBAAqB,sBAAsB,EAAE,qCAAqC,EAAE,6BAA6B,EAAE;AACnH,2BAA2B,6BAA6B,EAAE;AAC1D,wBAAwB,aAAa,EAAE,eAAe,EAAE;AACxD,8BAA8B,mCAAmC,EAAE,gBAAgB,EAAE;AACrF,oCAAoC,6BAA6B,EAAE,qCAAqC,EAAE;;AAE1G,sCAAsC;AACtC;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,uCAAuC;AACzC;AACA,oBAAoB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,UAAU,EAAE;AACzG,kBAAkB,kBAAkB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE","sourcesContent":["/* ============================================================\n   AgentShowcase — Growfit 전문 에이전트\n   다크 네이비 기반 에디토리얼 톤. 헤어라인 인덱스 + 세리프 번호.\n   브랜드 컬러(네이비)는 이 페이지 로컬 토큰으로만 정의 — 전역 토큰 미변경.\n   고정 헤더/사이드바 레이아웃(.prompt__layout) 안에서 .prompt__main 스크롤 영역만 사용.\n   ============================================================ */\n\n.gf-showcase-page {\n  --gf-ink: #0e1b2b;            /* 헤딩용 near-black 네이비 */\n  --gf-navy: #13314f;           /* 브랜드 네이비 */\n  --gf-navy-soft: #3c5a78;      /* 보조 네이비 */\n  --gf-muted: #5c6b7a;          /* 본문 보조 */\n  --gf-faint: #8a98a6;          /* 약한 텍스트 */\n  --gf-line: rgba(14, 27, 43, 0.12);\n  --gf-line-strong: rgba(14, 27, 43, 0.22);\n  --gf-brass: #9a7b4f;          /* 절제된 황동 액센트(소량) */\n  --gf-serif: \"Newsreader\", Georgia, serif;\n}\n\n/* 배경은 다른 페이지와 동일하게(.prompt__main 기본 흰색) 유지 */\n.gf-showcase-page .prompt__content {\n  padding: 56px 60px 72px;\n}\n\n/* ============================================================\n   목록 — 에디토리얼 인덱스\n   ============================================================ */\n.gf-showcase {\n  max-width: 1180px;\n}\n\n/* ── 마스트헤드 ── */\n.gf-showcase__mast {\n  opacity: 0;\n  animation: gfRise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) forwards;\n}\n\n.gf-showcase__eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: var(--gf-navy-soft);\n}\n\n.gf-showcase__eyebrow::before {\n  content: \"\";\n  flex: none;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--gf-brass);\n}\n\n.gf-showcase__headline {\n  margin: 20px 0 0;\n  font-size: 42px;\n  line-height: 1.14;\n  letter-spacing: -0.03em;\n  font-weight: 800;\n  color: var(--gf-ink);\n}\n\n.gf-showcase__headline .gf-dim {\n  color: var(--gf-faint);\n  font-weight: 300;\n}\n\n.gf-showcase__deck {\n  margin: 18px 0 0;\n  max-width: 640px;\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--gf-muted);\n  word-break: keep-all;\n}\n\n.gf-showcase__rule {\n  margin: 38px 0 0;\n  height: 1px;\n  background: var(--gf-line-strong);\n}\n\n/* ── 인덱스 ── */\n.gf-showcase__index {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.gf-item {\n  position: relative;\n  display: grid;\n  grid-template-columns: 88px 1fr 40px;\n  align-items: start;\n  gap: 8px;\n  padding: 30px 8px 28px;\n  border-bottom: 1px solid var(--gf-line);\n  cursor: pointer;\n  opacity: 0;\n  transform: translateY(10px);\n  animation: gfRise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) forwards;\n  transition: background 0.35s ease;\n}\n\n.gf-item:hover {\n  background: linear-gradient(90deg, rgba(19, 49, 79, 0.05), rgba(19, 49, 79, 0) 72%);\n}\n\n.gf-item:focus-visible {\n  outline: none;\n  background: linear-gradient(90deg, rgba(19, 49, 79, 0.07), rgba(19, 49, 79, 0) 72%);\n}\n\n.gf-item__num {\n  font-family: var(--gf-serif);\n  font-style: italic;\n  font-weight: 300;\n  font-size: 46px;\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: var(--gf-faint);\n  transition: color 0.35s ease;\n}\n\n.gf-item:hover .gf-item__num {\n  color: var(--gf-navy);\n}\n\n.gf-item__name {\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--gf-ink);\n}\n\n.gf-item__official {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 12px;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--gf-brass);\n  vertical-align: middle;\n}\n\n.gf-item__official::before {\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  border: 1px solid var(--gf-brass);\n  border-radius: 50%;\n}\n\n.gf-item__desc {\n  margin: 10px 0 0;\n  max-width: 820px;\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--gf-muted);\n}\n\n.gf-item__meta {\n  margin: 16px 0 0;\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  font-size: 12.5px;\n}\n\n.gf-item__meta-k {\n  flex: none;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--gf-navy);\n}\n\n.gf-item__meta-v {\n  color: var(--gf-faint);\n  line-height: 1.5;\n}\n\n.gf-item__tags {\n  margin: 9px 0 0;\n  font-size: 12px;\n  letter-spacing: 0.01em;\n  color: var(--gf-faint);\n}\n\n.gf-item__arrow {\n  justify-self: end;\n  align-self: center;\n  display: inline-flex;\n  color: var(--gf-line-strong);\n  transition: color 0.35s ease, transform 0.35s ease;\n}\n\n.gf-item:hover .gf-item__arrow {\n  color: var(--gf-navy);\n  transform: translateX(4px);\n}\n\n/* 스태거 로드 */\n.gf-showcase__mast { animation-delay: 0s; }\n.gf-item:nth-child(1) { animation-delay: 0.06s; }\n.gf-item:nth-child(2) { animation-delay: 0.15s; }\n.gf-item:nth-child(3) { animation-delay: 0.24s; }\n.gf-item:nth-child(4) { animation-delay: 0.33s; }\n.gf-item:nth-child(5) { animation-delay: 0.42s; }\n\n@keyframes gfRise {\n  to { opacity: 1; transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .gf-showcase__mast,\n  .gf-item { animation: none; opacity: 1; transform: none; }\n}\n\n/* ============================================================\n   상세 — 에디토리얼 아티클\n   ============================================================ */\n.gf-detail {\n  max-width: 720px;\n  opacity: 0;\n  animation: gfRise 0.6s cubic-bezier(0.2, 0.7, 0.2, 1) forwards;\n}\n\n.gf-detail__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 30px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--gf-faint);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.25s ease;\n}\n\n.gf-detail__back:hover {\n  color: var(--gf-navy);\n}\n\n/* 헤드 */\n.gf-detail__eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--gf-brass);\n}\n\n.gf-detail__eyebrow::before {\n  content: \"\";\n  flex: none;\n  width: 5px;\n  height: 5px;\n  border: 1px solid var(--gf-brass);\n  border-radius: 50%;\n}\n\n.gf-detail__name {\n  margin: 16px 0 0;\n  font-size: 34px;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n  font-weight: 800;\n  color: var(--gf-ink);\n}\n\n.gf-detail__deck {\n  margin: 16px 0 0;\n  font-size: 15.5px;\n  line-height: 1.68;\n  color: var(--gf-muted);\n  max-width: 600px;\n  word-break: keep-all;\n  text-wrap: pretty;\n}\n\n/* 해자 풀-쿼트 */\n.gf-detail__quote {\n  margin: 30px 0 0;\n  padding: 4px 0 4px 22px;\n  border-left: 2px solid var(--gf-navy);\n}\n\n.gf-detail__quote-label {\n  display: block;\n  margin-bottom: 7px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--gf-navy);\n}\n\n.gf-detail__quote-text {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.62;\n  color: var(--gf-ink);\n}\n\n/* 섹션 */\n.gf-detail__sec {\n  margin-top: 40px;\n  padding-top: 28px;\n  border-top: 1px solid var(--gf-line);\n}\n\n.gf-detail__label {\n  margin: 0 0 16px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--gf-navy-soft);\n}\n\n/* 무엇을 하나 — 대시 리스트 */\n.gf-detail__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.gf-detail__list-item {\n  position: relative;\n  padding: 0 0 0 22px;\n  margin: 12px 0;\n  font-size: 14.5px;\n  line-height: 1.62;\n  color: var(--gf-muted);\n}\n\n.gf-detail__list-item::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 11px;\n  width: 12px;\n  height: 1px;\n  background: var(--gf-navy);\n}\n\n/* 전문성의 근거 — 하어라인 분리 행 */\n.gf-detail__evidence {\n  display: flex;\n  flex-direction: column;\n}\n\n.gf-detail__evidence-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 2px;\n  font-size: 14px;\n  color: var(--gf-ink);\n  border-top: 1px solid var(--gf-line);\n}\n\n.gf-detail__evidence-item:first-child {\n  border-top: none;\n}\n\n.gf-detail__evidence-item::before {\n  content: \"\";\n  flex: none;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--gf-brass);\n}\n\n/* 예시 질문 */\n.gf-detail__samples {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.gf-detail__sample {\n  position: relative;\n  margin: 0;\n  padding: 13px 16px 13px 40px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--gf-ink);\n  background: rgba(19, 49, 79, 0.035);\n  border-radius: 2px;\n}\n\n.gf-detail__sample::before {\n  content: \"\\201C\";\n  position: absolute;\n  left: 14px;\n  top: 6px;\n  font-family: var(--gf-serif);\n  font-style: italic;\n  font-size: 28px;\n  line-height: 1;\n  color: var(--gf-brass);\n}\n\n/* CTA */\n.gf-detail__cta {\n  margin-top: 44px;\n}\n\n.gf-detail__cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px 28px;\n  font-size: 13.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #fff;\n  background: var(--gf-navy);\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: background 0.25s ease, transform 0.25s ease;\n}\n\n.gf-detail__cta-btn:hover {\n  background: var(--gf-ink);\n  transform: translateY(-1px);\n}\n\n.gf-detail__empty {\n  font-size: 14px;\n  color: var(--gf-muted);\n}\n\n/* ── 이어서 하기 — 지난 대화(run) 목록 (CTA 아래) ── */\n.gf-resume__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.gf-resume__row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  padding: 14px 18px;\n  background: rgba(19, 49, 79, 0.025);\n  border: 1px solid var(--gf-line);\n  border-radius: 2px;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n.gf-resume__row:hover {\n  background: rgba(19, 49, 79, 0.05);\n  border-color: var(--gf-line-strong);\n  transform: translateX(2px);\n}\n\n.gf-resume__dot {\n  flex: none;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--gf-faint);\n}\n\n.gf-resume__dot--paused { background: var(--gf-brass); }\n.gf-resume__dot--done { background: var(--gf-navy); }\n.gf-resume__dot--error { background: #c0492f; }\n.gf-resume__dot--running { background: var(--gf-navy-soft); }\n\n.gf-resume__body {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.gf-resume__title {\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--gf-ink);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gf-resume__date {\n  font-size: 12px;\n  color: var(--gf-faint);\n  font-variant-numeric: tabular-nums;\n}\n\n.gf-resume__action {\n  flex: none;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--gf-navy);\n}\n\n/* 이어하기 더 보기/접기 토글 */\n.gf-resume__more {\n  width: 100%;\n  margin-top: 8px;\n  padding: 10px;\n  background: transparent;\n  border: 1px solid var(--gf-line);\n  border-radius: 2px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.gf-resume__more:hover {\n  background: rgba(19, 49, 79, 0.04);\n  border-color: var(--gf-line-strong);\n}\n\n/* ============================================================\n   작업 화면 — 좌: 대화 / 우: 산출물 패널(자동 오픈)\n   목록·상세와 동일한 네이비 에디토리얼 언어.\n   ============================================================ */\n\n/* 다른 페이지와 동일한 카드형 셸 (헤더 아래 전체 영역) */\n.gf-work-page .gf-work {\n  display: flex;\n  flex-direction: column;\n  margin: 0 16px;\n  min-height: calc(100vh - 52px);\n  height: calc(100vh - 52px);\n  background: #fff;\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);\n  overflow: hidden;\n}\n\n/* 에이전트 식별 바 */\n.gf-work__bar {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  height: 56px;\n  padding: 0 22px;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-work__bar-name {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink);\n}\n\n.gf-work__bar-tag {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--gf-brass);\n  border: 1px solid rgba(154, 123, 79, 0.4);\n  border-radius: 999px;\n  padding: 2px 9px;\n}\n\n.gf-work__bar-close {\n  margin-left: auto;\n  display: inline-flex;\n  padding: 6px;\n  color: var(--gf-faint);\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: color 0.2s ease, background 0.2s ease;\n}\n\n.gf-work__bar-close:hover {\n  color: var(--gf-ink);\n  background: rgba(14, 27, 43, 0.05);\n}\n\n/* 상단 바 \"수집 정보\" 버튼 — 우측 정렬(close 앞) */\n.gf-work__bar-info {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  background: none;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.gf-work__bar-info:hover {\n  background: rgba(14, 27, 43, 0.05);\n  border-color: var(--gf-navy);\n}\n.gf-work__bar-info + .gf-work__bar-close { margin-left: 0; }\n\n/* 수집 정보 모달 — 인테이크 폼(.gf-intake) 셸·그룹·라벨 재사용, 읽기 전용 변형.\n   폼 전용 추가 규칙만 여기 둔다(셸/그룹/라벨/푸터는 .gf-intake 원본 그대로). */\n.gf-intake__head--review {\n  position: relative;\n  padding-bottom: 22px;\n}\n/* 헤더 우상단 닫기 — 스텝퍼가 없는 리뷰 모달용 */\n.gf-intake__review-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  display: inline-flex;\n  padding: 6px;\n  color: var(--gf-faint);\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 6px;\n}\n.gf-intake__review-close:hover { color: var(--gf-ink); background: rgba(14, 27, 43, 0.05); }\n/* 읽기 전용 값 — 폼 컨트롤 자리에 정적 텍스트 */\n.gf-intake__value {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--gf-ink);\n  word-break: break-word;\n}\n.gf-intake__review-state {\n  padding: 28px 0;\n  font-size: 13px;\n  color: var(--gf-muted);\n  text-align: center;\n}\n\n/* 무대(대화 | 패널) */\n.gf-work__stage {\n  flex: 1;\n  display: flex;\n  min-height: 0;\n}\n\n/* 대화 컬럼 */\n.gf-work__chat {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.gf-work__scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 36px 0 12px;\n}\n\n.gf-work__col {\n  max-width: 720px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 32px;\n}\n\n/* 메시지 */\n.gf-msg {\n  margin-bottom: 24px;\n}\n\n.gf-msg__who {\n  display: block;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--gf-faint);\n  margin-bottom: 8px;\n}\n\n.gf-msg--user {\n  text-align: right;\n}\n\n.gf-msg__text {\n  margin: 0;\n  font-size: 14.5px;\n  line-height: 1.72;\n  color: #26323f;\n}\n\n.gf-msg--user .gf-msg__body {\n  display: inline-block;\n  text-align: left;\n  max-width: 80%;\n  padding: 12px 16px;\n  background: rgba(19, 49, 79, 0.06);\n  border-radius: 12px 12px 4px 12px;\n}\n\n.gf-msg--user .gf-msg__text {\n  color: var(--gf-ink);\n  font-size: 14px;\n}\n\n/* 대화 속 아티팩트 칩 */\n.gf-work__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 11px;\n  margin-top: 12px;\n  padding: 11px 15px;\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 10px;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.gf-work__chip:hover {\n  border-color: var(--gf-navy);\n  box-shadow: 0 2px 10px rgba(14, 27, 43, 0.08);\n}\n\n.gf-work__chip-ic {\n  flex: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  background: rgba(19, 49, 79, 0.08);\n  color: var(--gf-navy);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n}\n\n.gf-work__chip-title {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gf-ink);\n}\n\n.gf-work__chip-meta {\n  display: block;\n  font-size: 11px;\n  color: var(--gf-faint);\n  margin-top: 1px;\n}\n\n.gf-work__chip-go {\n  margin-left: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--gf-navy-soft);\n}\n\n/* 입력부 */\n.gf-work__composer {\n  padding-top: 14px;\n  padding-bottom: 24px;\n}\n\n.gf-work__starters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.gf-work__starter {\n  font-size: 12.5px;\n  color: var(--gf-navy);\n  background: rgba(19, 49, 79, 0.05);\n  border: 1px solid var(--gf-line);\n  border-radius: 999px;\n  padding: 7px 14px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.gf-work__starter:hover {\n  background: rgba(19, 49, 79, 0.1);\n}\n\n.gf-work__input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 12px 11px 16px;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 12px;\n  background: #fff;\n  transition: border-color 0.2s ease;\n}\n\n.gf-work__input:focus-within {\n  border-color: var(--gf-navy);\n}\n\n.gf-work__input-field {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: none;\n  font-size: 14px;\n  color: var(--gf-ink);\n  font-family: inherit;\n}\n\n.gf-work__send {\n  flex: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--gf-navy);\n  color: #fff;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.gf-work__send:hover {\n  background: var(--gf-ink);\n}\n\n/* ── 입력창 첨부 버튼 ── */\n.gf-work__attach-btn {\n  flex: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: transparent;\n  color: rgba(19, 49, 79, 0.55);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.gf-work__attach-btn:hover {\n  background: rgba(19, 49, 79, 0.07);\n  color: var(--gf-navy);\n}\n\n.gf-work__attach-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ── 선택된 첨부 칩(입력창 위) ── */\n.gf-work__attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.gf-work__attach {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 260px;\n  padding: 6px 8px 6px 10px;\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 8px;\n  font-size: 12.5px;\n  color: var(--gf-ink);\n}\n\n.gf-work__attach-ic {\n  flex: none;\n  display: flex;\n  color: rgba(19, 49, 79, 0.55);\n}\n\n.gf-work__attach-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gf-work__attach-size {\n  flex: none;\n  color: rgba(19, 49, 79, 0.5);\n  font-size: 11.5px;\n}\n\n.gf-work__attach-x {\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 5px;\n  background: transparent;\n  color: rgba(19, 49, 79, 0.5);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.gf-work__attach-x:hover {\n  background: rgba(19, 49, 79, 0.08);\n  color: var(--gf-navy);\n}\n\n/* ── 보낸 메시지 버블의 첨부 칩 ── */\n.gf-msg__files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.gf-msg__file {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 240px;\n  padding: 5px 9px;\n  background: rgba(19, 49, 79, 0.05);\n  border: 1px solid var(--gf-line);\n  border-radius: 7px;\n  font-size: 12px;\n  color: var(--gf-ink);\n}\n\n.gf-msg__file-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.gf-msg__file-size {\n  flex: none;\n  color: rgba(19, 49, 79, 0.5);\n  font-size: 11px;\n}\n\n/* ── 우측 아티팩트 패널 ── */\n.gf-work__panel {\n  flex: none;\n  width: 880px;\n  display: flex;\n  flex-direction: column;\n  border-left: 1px solid var(--gf-line);\n  background: #fff;\n  overflow: hidden;\n  animation: gfPanelIn 0.42s cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n\n@keyframes gfPanelIn {\n  from { width: 0; opacity: 0; }\n  to { width: 880px; opacity: 1; }\n}\n\n.gf-work__panel-head {\n  flex: none;\n  display: flex;\n  align-items: center;\n  height: 50px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-work__panel-title {\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--gf-navy-soft);\n}\n\n.gf-work__panel-close {\n  margin-left: auto;\n  display: inline-flex;\n  padding: 5px;\n  color: var(--gf-faint);\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: color 0.2s ease, background 0.2s ease;\n}\n\n.gf-work__panel-close:hover {\n  color: var(--gf-ink);\n  background: rgba(14, 27, 43, 0.05);\n}\n\n.gf-work__panel-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 26px 28px;\n  animation: gfFadeIn 0.3s ease;\n}\n\n/* 패널은 열린 채로 두고 본문만 교체될 때의 부드러운 전환 */\n@keyframes gfFadeIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: none; }\n}\n\n.gf-work__panel-foot {\n  flex: none;\n  display: flex;\n  gap: 8px;\n  padding: 13px 16px;\n  border-top: 1px solid var(--gf-line);\n}\n\n.gf-work__panel-btn {\n  flex: 1;\n  height: 38px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  background: none;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease;\n}\n\n.gf-work__panel-btn:hover {\n  border-color: var(--gf-navy);\n  color: var(--gf-ink);\n}\n\n/* 폼 아티팩트 */\n.gf-form__title {\n  margin: 0 0 5px;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink);\n}\n\n.gf-form__sub {\n  margin: 0 0 20px;\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: var(--gf-muted);\n}\n\n.gf-form__field {\n  margin-bottom: 15px;\n}\n\n.gf-form__field label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--gf-navy);\n  margin-bottom: 7px;\n}\n\n.gf-form__ctrl {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 42px;\n  padding: 0 13px;\n  font-size: 13px;\n  color: var(--gf-ink);\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 8px;\n}\n\n.gf-form__ctrl span {\n  color: var(--gf-faint);\n}\n\n.gf-form__submit {\n  margin-top: 10px;\n  width: 100%;\n  height: 44px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  color: #fff;\n  background: var(--gf-navy);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.gf-form__submit:hover {\n  background: var(--gf-ink);\n}\n\n/* 결과 아티팩트 — 상세의 evidence 행과 동일 언어 */\n.gf-result__row {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  padding: 14px 2px;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-result__row:first-child {\n  border-top: 1px solid var(--gf-line);\n}\n\n.gf-result__dot {\n  flex: none;\n  width: 7px;\n  height: 7px;\n  border-radius: 2px;\n  background: var(--gf-navy);\n}\n\n.gf-result__main {\n  flex: 1;\n  min-width: 0;\n}\n\n.gf-result__name {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--gf-ink);\n}\n\n.gf-result__sub {\n  margin-top: 3px;\n  font-size: 11.5px;\n  color: var(--gf-faint);\n}\n\n.gf-result__dday {\n  flex: none;\n  font-family: var(--gf-serif);\n  font-style: italic;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--gf-brass);\n}\n\n@media (max-width: 1380px) {\n  .gf-work__panel { width: 620px; }\n  @keyframes gfPanelIn { from { width: 0; opacity: 0; } to { width: 620px; opacity: 1; } }\n}\n\n@media (max-width: 1040px) {\n  .gf-work__panel { width: 460px; }\n  @keyframes gfPanelIn { from { width: 0; opacity: 0; } to { width: 460px; opacity: 1; } }\n}\n\n/* ============================================================\n   아티팩트 렌더러 — 범용 type별 (동일 네이비 에디토리얼 언어)\n   ============================================================ */\n\n/* upload */\n.gf-upload__drop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n  padding: 30px 16px;\n  margin-bottom: 14px;\n  color: var(--gf-navy-soft);\n  text-align: center;\n  border: 1.5px dashed var(--gf-line-strong);\n  border-radius: 10px;\n  background: rgba(19, 49, 79, 0.02);\n}\n\n.gf-upload__drop-text { font-size: 13px; color: var(--gf-muted); }\n.gf-upload__hint { font-size: 11.5px; color: var(--gf-faint); }\n\n/* connect (OAuth) */\n.gf-connect__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px;\n  margin-bottom: 14px;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 10px;\n}\n\n.gf-connect__logo {\n  flex: none;\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n  background: rgba(19, 49, 79, 0.08);\n  color: var(--gf-navy);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.gf-connect__info { flex: 1; min-width: 0; }\n.gf-connect__name { font-size: 14px; font-weight: 700; color: var(--gf-ink); }\n.gf-connect__desc { margin-top: 2px; font-size: 11.5px; color: var(--gf-faint); }\n.gf-connect__status {\n  flex: none;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--gf-faint);\n  border: 1px solid var(--gf-line);\n  border-radius: 999px;\n  padding: 3px 9px;\n}\n\n/* choice */\n.gf-choice { display: flex; flex-direction: column; gap: 9px; margin-bottom: 14px; }\n\n.gf-choice__opt {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  padding: 13px 14px;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.gf-choice__opt:hover { border-color: var(--gf-navy); }\n.gf-choice__opt input { margin-top: 3px; accent-color: var(--gf-navy); }\n.gf-choice__opt-body { display: flex; flex-direction: column; gap: 3px; }\n.gf-choice__opt-title { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }\n.gf-choice__opt-desc { font-size: 12px; color: var(--gf-faint); }\n\n/* progress */\n.gf-progress { display: flex; flex-direction: column; }\n\n.gf-progress__step {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 13px 2px;\n  border-bottom: 1px solid var(--gf-line);\n  font-size: 13.5px;\n  color: var(--gf-muted);\n}\n\n.gf-progress__step:first-child { border-top: 1px solid var(--gf-line); }\n.gf-progress__dot {\n  flex: none;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  border: 2px solid var(--gf-line-strong);\n  background: transparent;\n}\n\n.gf-progress__step--done .gf-progress__dot { background: var(--gf-navy); border-color: var(--gf-navy); }\n.gf-progress__step--running .gf-progress__dot { border-color: var(--gf-brass); background: var(--gf-brass); animation: gfPulse 1.1s ease-in-out infinite; }\n.gf-progress__step--done .gf-progress__label,\n.gf-progress__step--running .gf-progress__label { color: var(--gf-ink); }\n.gf-progress__label { flex: 1; }\n.gf-progress__state { flex: none; font-size: 11px; font-weight: 600; color: var(--gf-faint); }\n.gf-progress__step--running .gf-progress__state { color: var(--gf-brass); }\n\n@keyframes gfPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }\n\n/* detail — key/value */\n.gf-kv { display: flex; flex-direction: column; }\n.gf-kv__row {\n  display: flex;\n  gap: 14px;\n  padding: 12px 2px;\n  border-bottom: 1px solid var(--gf-line);\n  font-size: 13.5px;\n}\n.gf-kv__row:first-child { border-top: 1px solid var(--gf-line); }\n.gf-kv__k { flex: none; width: 76px; font-weight: 700; color: var(--gf-navy); letter-spacing: 0.02em; }\n.gf-kv__v { flex: 1; color: var(--gf-ink); line-height: 1.5; }\n\n/* document */\n.gf-doc__h {\n  margin: 18px 0 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--gf-ink);\n  letter-spacing: -0.01em;\n}\n.gf-doc__h:first-child { margin-top: 0; }\n.gf-doc__p { margin: 0; font-size: 13.5px; line-height: 1.7; color: var(--gf-muted); }\n\n/* compare */\n.gf-compare { display: flex; flex-direction: column; }\n.gf-compare__row {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--gf-line);\n}\n.gf-compare__row--head { border-bottom: 1px solid var(--gf-line-strong); }\n.gf-compare__k {\n  flex: none;\n  width: 84px;\n  padding: 11px 8px 11px 2px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--gf-navy);\n}\n.gf-compare__c {\n  flex: 1;\n  padding: 11px 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--gf-ink);\n  text-align: center;\n}\n.gf-compare__v {\n  flex: 1;\n  padding: 11px 8px;\n  font-size: 13px;\n  color: var(--gf-muted);\n  text-align: center;\n}\n\n/* checklist */\n.gf-check { display: flex; flex-direction: column; }\n.gf-check__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 2px;\n  border-bottom: 1px solid var(--gf-line);\n  font-size: 13.5px;\n  color: var(--gf-muted);\n}\n.gf-check__row:first-child { border-top: 1px solid var(--gf-line); }\n.gf-check__box {\n  flex: none;\n  width: 19px;\n  height: 19px;\n  border-radius: 5px;\n  border: 1.5px solid var(--gf-line-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.gf-check__row--done .gf-check__box { background: var(--gf-navy); border-color: var(--gf-navy); }\n.gf-check__row--done .gf-check__label { color: var(--gf-ink); }\n.gf-check__label { flex: 1; }\n\n/* timeline */\n.gf-timeline { display: flex; flex-direction: column; }\n.gf-timeline__row { display: flex; gap: 12px; }\n.gf-timeline__date {\n  flex: none;\n  width: 44px;\n  padding-top: 1px;\n  font-family: var(--gf-serif);\n  font-style: italic;\n  font-size: 14px;\n  color: var(--gf-brass);\n}\n.gf-timeline__rail { flex: none; position: relative; width: 12px; display: flex; justify-content: center; }\n.gf-timeline__rail::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--gf-line);\n}\n.gf-timeline__row:first-child .gf-timeline__rail::before { top: 6px; }\n.gf-timeline__row:last-child .gf-timeline__rail::before { bottom: auto; height: 6px; }\n.gf-timeline__dot {\n  position: relative;\n  margin-top: 5px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #fff;\n  border: 2px solid var(--gf-navy);\n}\n.gf-timeline__body { flex: 1; padding: 0 0 20px; }\n.gf-timeline__label { display: block; font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }\n.gf-timeline__sub { display: block; margin-top: 2px; font-size: 11.5px; color: var(--gf-faint); }\n\n/* state — empty / error / permission */\n.gf-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 36px 18px 24px;\n}\n.gf-state__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  margin-bottom: 16px;\n  color: var(--gf-navy-soft);\n  background: rgba(19, 49, 79, 0.06);\n}\n.gf-state--error .gf-state__icon { color: #b4524a; background: rgba(180, 82, 74, 0.1); }\n.gf-state--permission .gf-state__icon { color: var(--gf-brass); background: rgba(154, 123, 79, 0.12); }\n.gf-state__title { margin: 0 0 6px; font-size: 16px; font-weight: 700; color: var(--gf-ink); }\n.gf-state__sub { margin: 0 0 20px; font-size: 13px; line-height: 1.55; color: var(--gf-muted); max-width: 280px; }\n.gf-state__btn { width: auto; padding-left: 28px; padding-right: 28px; }\n\n/* preview — 생성 파일(iframe) 뷰어. 패널 본문을 가득 채움 */\n.gf-work__panel-body--flush {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.gf-preview {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.gf-preview__bar {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 18px;\n  border-bottom: 1px solid var(--gf-line);\n  background: #fff;\n}\n\n.gf-preview__file-ic {\n  display: inline-flex;\n  color: var(--gf-navy);\n}\n\n.gf-preview__file-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gf-ink);\n}\n\n.gf-preview__file-type {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--gf-brass);\n  border: 1px solid rgba(154, 123, 79, 0.45);\n  border-radius: 4px;\n  padding: 1px 6px;\n}\n\n.gf-preview__stage {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  background: #e9e7e2;\n}\n\n/* 뷰어는 전체 영역을 채우고, 문서(mock 2페이지 또는 실제 PDF)가 내부에서 스크롤 */\n.gf-preview__frame {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n}\n\n/* ============================================================\n   진입 동의 모달\n   ============================================================ */\n.gf-consent {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.gf-consent__scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(14, 27, 43, 0.45);\n  animation: gfFadeIn 0.25s ease;\n}\n\n.gf-consent__card {\n  position: relative;\n  width: 100%;\n  max-width: 480px;\n  background: #fff;\n  border-radius: 14px;\n  padding: 30px 30px 24px;\n  box-shadow: 0 30px 70px -20px rgba(14, 27, 43, 0.5);\n  animation: gfConsentIn 0.32s cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n\n@keyframes gfConsentIn {\n  from { opacity: 0; transform: translateY(12px) scale(0.98); }\n  to { opacity: 1; transform: none; }\n}\n\n.gf-consent__eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--gf-brass);\n}\n\n.gf-consent__title {\n  margin: 12px 0 0;\n  font-size: 21px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--gf-ink);\n}\n\n.gf-consent__intro {\n  margin: 10px 0 0;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: var(--gf-muted);\n}\n\n/* 전체 동의 토글 버튼 */\n.gf-consent__all {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin: 22px 0 10px;\n  padding: 15px 16px;\n  border: 1.5px solid var(--gf-navy);\n  border-radius: 10px;\n  background: rgba(19, 49, 79, 0.03);\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.gf-consent__all:hover,\n.gf-consent__all--on {\n  background: rgba(19, 49, 79, 0.06);\n}\n\n.gf-consent__all-label {\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink);\n}\n\n.gf-consent__list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 0;\n}\n\n.gf-consent__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 15px 16px;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.gf-consent__item:hover {\n  border-color: var(--gf-navy);\n  background: rgba(19, 49, 79, 0.02);\n}\n\n.gf-consent__cb {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.gf-consent__box {\n  flex: none;\n  margin-top: 1px;\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  border: 1.5px solid var(--gf-line-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  transition: background 0.18s ease, border-color 0.18s ease;\n}\n\n.gf-consent__box--on {\n  background: var(--gf-navy);\n  border-color: var(--gf-navy);\n}\n\n.gf-consent__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.gf-consent__row-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.gf-consent__label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--gf-ink);\n}\n\n.gf-consent__tag {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  color: var(--gf-faint);\n  border: 1px solid var(--gf-line);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.gf-consent__tag--req {\n  color: var(--gf-navy);\n  border-color: rgba(19, 49, 79, 0.35);\n}\n\n.gf-consent__desc {\n  display: block;\n  margin-top: 5px;\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: var(--gf-muted);\n}\n\n.gf-consent__foot {\n  display: flex;\n  gap: 10px;\n  margin: 24px 0 0;\n}\n\n.gf-consent__btn {\n  flex: 1;\n  height: 46px;\n  font-size: 13.5px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border-radius: 9px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.gf-consent__btn--ghost {\n  flex: 0 0 auto;\n  padding: 0 20px;\n  color: var(--gf-muted);\n  background: none;\n  border: 1px solid var(--gf-line-strong);\n}\n\n.gf-consent__btn--ghost:hover {\n  color: var(--gf-ink);\n  border-color: var(--gf-navy-soft);\n}\n\n.gf-consent__btn--primary {\n  color: #fff;\n  background: var(--gf-navy);\n  border: none;\n}\n\n.gf-consent__btn--primary:hover {\n  background: var(--gf-ink);\n}\n\n.gf-consent__btn--primary:disabled {\n  background: var(--gf-line-strong);\n  cursor: not-allowed;\n}\n\n.gf-consent__note {\n  margin: 14px 0 0;\n  font-size: 11.5px;\n  color: var(--gf-faint);\n  text-align: center;\n}\n\n/* ============================================================\n   프로필 수집 폼 — 활용 전 기업·대표 정보 (2-step 위저드)\n   동의 모달과 같은 다크 네이비 에디토리얼 언어. 시트형 대형 카드.\n   ============================================================ */\n.gf-intake {\n  position: fixed;\n  inset: 0;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n}\n\n.gf-intake__scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(14, 27, 43, 0.5);\n  animation: gfFadeIn 0.25s ease;\n}\n\n.gf-intake__card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 760px;\n  max-height: 100%;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 34px 80px -24px rgba(14, 27, 43, 0.55);\n  overflow: hidden;\n  animation: gfConsentIn 0.32s cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n\n/* ── 헤더 (고정) ── */\n.gf-intake__head {\n  flex: none;\n  padding: 28px 34px 0;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-intake__eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--gf-brass);\n}\n\n.gf-intake__title {\n  margin: 10px 0 0;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--gf-ink);\n}\n\n.gf-intake__sub {\n  margin: 9px 0 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--gf-muted);\n  max-width: 600px;\n  word-break: keep-all;\n}\n\n.gf-intake__stepper {\n  display: flex;\n  gap: 10px;\n  margin: 22px 0 0;\n}\n\n.gf-intake__stepper-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex: 1;\n  padding: 13px 16px 15px;\n  border-bottom: 2px solid transparent;\n  color: var(--gf-faint);\n}\n\n.gf-intake__stepper-item.is-current {\n  border-bottom-color: var(--gf-navy);\n  color: var(--gf-ink);\n}\n\n.gf-intake__stepper-item.is-done {\n  color: var(--gf-navy-soft);\n}\n\n.gf-intake__stepper-num {\n  flex: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  background: rgba(14, 27, 43, 0.08);\n  color: inherit;\n}\n\n.gf-intake__stepper-item.is-current .gf-intake__stepper-num {\n  background: var(--gf-navy);\n  color: #fff;\n}\n\n.gf-intake__stepper-item.is-done .gf-intake__stepper-num {\n  background: rgba(19, 49, 79, 0.14);\n  color: var(--gf-navy);\n}\n\n.gf-intake__stepper-label {\n  font-size: 13.5px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.gf-intake__stepper-tag {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  padding: 2px 7px;\n  border-radius: 999px;\n  border: 1px solid var(--gf-line-strong);\n  color: var(--gf-faint);\n}\n\n.gf-intake__stepper-item.is-current .gf-intake__stepper-tag {\n  color: var(--gf-navy);\n  border-color: rgba(19, 49, 79, 0.35);\n}\n\n/* ── 본문 (스크롤) ── */\n.gf-intake__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 24px 34px 30px;\n}\n\n.gf-intake__step-desc {\n  margin: 0 0 22px;\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: var(--gf-muted);\n}\n\n.gf-intake__group {\n  padding: 0 0 22px;\n  margin-bottom: 22px;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-intake__group:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 4px;\n}\n\n.gf-intake__group-head {\n  margin-bottom: 16px;\n}\n\n.gf-intake__group-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: var(--gf-navy);\n}\n\n.gf-intake__group-desc {\n  margin: 6px 0 14px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--gf-muted);\n}\n\n/* 결격사유 그룹 — 절제된 경고 톤 */\n.gf-intake__group--danger {\n  padding: 20px;\n  border: 1px solid var(--warning-border, #e7d8b0);\n  border-radius: 12px;\n  background: var(--fg-bg-warning, #fbf7ec);\n}\n\n.gf-intake__group--danger .gf-intake__group-title {\n  color: #9a6b1f;\n}\n\n/* 필드 그리드 — 2열, full 클래스는 한 줄 차지 */\n.gf-intake__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 18px;\n}\n\n.gf-intake__field--full,\n.gf-intake__grid > .gf-intake__field--full {\n  grid-column: 1 / -1;\n}\n\n.gf-intake__field {\n  min-width: 0;\n}\n\n.gf-intake__label {\n  display: block;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink);\n  margin-bottom: 8px;\n}\n\n.gf-intake__req {\n  margin-left: 3px;\n  color: var(--gf-brass);\n}\n\n.gf-intake__note {\n  margin: 7px 0 0;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: var(--gf-faint);\n}\n\n/* select */\n.gf-intake__select {\n  position: relative;\n}\n\n.gf-intake__select-el {\n  width: 100%;\n  height: 44px;\n  padding: 0 38px 0 13px;\n  font-size: 13.5px;\n  font-family: inherit;\n  color: var(--gf-ink);\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 9px;\n  appearance: none;\n  cursor: pointer;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.gf-intake__select-el:focus {\n  outline: none;\n  border-color: var(--gf-navy);\n  box-shadow: 0 0 0 3px rgba(19, 49, 79, 0.1);\n}\n\n.gf-intake__select-el:invalid,\n.gf-intake__select-el[value=\"\"] {\n  color: var(--gf-faint);\n}\n\n.gf-intake__select-ic {\n  position: absolute;\n  top: 50%;\n  right: 13px;\n  transform: translateY(-50%);\n  color: var(--gf-faint);\n  pointer-events: none;\n}\n\n.gf-intake__select--err .gf-intake__select-el {\n  border-color: var(--error, #d24b4b);\n  box-shadow: 0 0 0 3px rgba(210, 75, 75, 0.08);\n}\n\n/* date — 설립일 + 미설립(예비창업) 토글 */\n.gf-intake__date {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.gf-intake__date-input {\n  flex: 1;\n  min-width: 150px;\n  height: 44px;\n  padding: 0 13px;\n  font-size: 13.5px;\n  font-family: inherit;\n  color: var(--gf-ink);\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 9px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.gf-intake__date-input:focus {\n  outline: none;\n  border-color: var(--gf-navy);\n  box-shadow: 0 0 0 3px rgba(19, 49, 79, 0.1);\n}\n\n.gf-intake__date-input:disabled {\n  background: rgba(14, 27, 43, 0.04);\n  color: var(--gf-faint);\n  cursor: not-allowed;\n}\n\n.gf-intake__date-input--err {\n  border-color: var(--error, #d24b4b);\n  box-shadow: 0 0 0 3px rgba(210, 75, 75, 0.08);\n}\n\n.gf-intake__date-pre {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--gf-navy-soft);\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 9px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.16s ease;\n}\n\n.gf-intake__date-pre:hover {\n  border-color: var(--gf-navy-soft);\n}\n\n.gf-intake__date-pre--on {\n  color: var(--gf-navy);\n  border-color: var(--gf-navy);\n  background: rgba(19, 49, 79, 0.05);\n}\n\n.gf-intake__date-pre-box {\n  flex: none;\n  width: 17px;\n  height: 17px;\n  border-radius: 5px;\n  border: 1.5px solid var(--gf-line-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  transition: background 0.16s ease, border-color 0.16s ease;\n}\n\n.gf-intake__date-pre-box--on {\n  background: var(--gf-navy);\n  border-color: var(--gf-navy);\n}\n\n/* segmented / yes-no */\n.gf-intake__seg {\n  display: inline-flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.gf-intake__seg--yn {\n  width: 100%;\n}\n\n.gf-intake__seg-btn {\n  min-width: 64px;\n  height: 40px;\n  padding: 0 16px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--gf-navy-soft);\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 9px;\n  cursor: pointer;\n  transition: all 0.16s ease;\n}\n\n.gf-intake__seg--yn .gf-intake__seg-btn {\n  flex: 1;\n}\n\n.gf-intake__seg-btn:hover {\n  border-color: var(--gf-navy-soft);\n}\n\n.gf-intake__seg-btn--on {\n  color: #fff;\n  background: var(--gf-navy);\n  border-color: var(--gf-navy);\n}\n\n.gf-intake__seg-btn--danger-on {\n  color: #fff;\n  background: #c2611f;\n  border-color: #c2611f;\n}\n\n/* chips (다중) */\n.gf-intake__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n  padding: 2px;\n  border-radius: 10px;\n}\n\n.gf-intake__chips--err {\n  outline: 2px solid rgba(210, 75, 75, 0.18);\n  outline-offset: 4px;\n}\n\n.gf-intake__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 38px;\n  padding: 0 15px;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--gf-navy);\n  background: rgba(19, 49, 79, 0.04);\n  border: 1px solid var(--gf-line);\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.16s ease;\n}\n\n.gf-intake__chip:hover {\n  border-color: var(--gf-navy-soft);\n  background: rgba(19, 49, 79, 0.07);\n}\n\n.gf-intake__chip--on {\n  color: #fff;\n  background: var(--gf-navy);\n  border-color: var(--gf-navy);\n}\n\n.gf-intake__chip-ck {\n  display: inline-flex;\n}\n\n/* text */\n.gf-intake__text {\n  width: 100%;\n  height: 44px;\n  padding: 0 13px;\n  font-size: 13.5px;\n  font-family: inherit;\n  color: var(--gf-ink);\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 9px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.gf-intake__text:focus {\n  outline: none;\n  border-color: var(--gf-navy);\n  box-shadow: 0 0 0 3px rgba(19, 49, 79, 0.1);\n}\n\n.gf-intake__text::placeholder {\n  color: var(--gf-faint);\n}\n\n/* progressive disclosure 게이트 */\n.gf-intake__gate {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 13px 16px;\n  margin-bottom: 16px;\n  background: rgba(19, 49, 79, 0.03);\n  border: 1px solid var(--gf-line);\n  border-radius: 10px;\n}\n\n.gf-intake__gate-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gf-ink);\n}\n\n.gf-intake__gate .gf-intake__seg--yn {\n  width: auto;\n  flex: none;\n}\n\n.gf-intake__gate .gf-intake__seg-btn {\n  flex: none;\n  min-width: 60px;\n}\n\n/* 민감정보 인라인 동의 */\n/* 단일 체크박스 필드(commitment 등) */\n.gf-intake__checkbox {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.18s ease, background 0.18s ease;\n}\n.gf-intake__checkbox:hover { border-color: var(--gf-navy-soft); }\n.gf-intake__checkbox--on { border-color: var(--gf-navy); background: rgba(19, 49, 79, 0.05); }\n.gf-intake__checkbox-box {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  border: 1.5px solid var(--gf-line-strong);\n  border-radius: 5px;\n  color: #fff;\n}\n.gf-intake__checkbox-box--on { background: var(--gf-navy); border-color: var(--gf-navy); }\n.gf-intake__checkbox-label { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); line-height: 1.45; }\n\n.gf-intake__sensitive {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.gf-intake__consent {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  width: 100%;\n  text-align: left;\n  padding: 14px 15px;\n  background: rgba(19, 49, 79, 0.025);\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.18s ease, background 0.18s ease;\n}\n\n.gf-intake__consent:hover {\n  border-color: var(--gf-navy-soft);\n}\n\n.gf-intake__consent--on {\n  border-color: var(--gf-navy);\n  background: rgba(19, 49, 79, 0.05);\n}\n\n.gf-intake__consent-box {\n  flex: none;\n  margin-top: 1px;\n  width: 19px;\n  height: 19px;\n  border-radius: 6px;\n  border: 1.5px solid var(--gf-line-strong);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  transition: background 0.16s ease, border-color 0.16s ease;\n}\n\n.gf-intake__consent-box--on {\n  background: var(--gf-navy);\n  border-color: var(--gf-navy);\n}\n\n.gf-intake__consent-lead {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--gf-ink);\n}\n\n.gf-intake__consent-tag {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  padding: 1px 7px;\n  border-radius: 999px;\n  border: 1px solid var(--gf-line);\n  color: var(--gf-faint);\n}\n\n.gf-intake__consent-desc {\n  display: block;\n  margin-top: 5px;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: var(--gf-muted);\n}\n\n/* 그룹 단위 동의 박스 + 4대 고지(목적·항목·기간·거부권) */\n.gf-intake__consent-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.gf-intake__consent-meta {\n  margin: 0;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: rgba(19, 49, 79, 0.02);\n  border: 1px solid var(--gf-line);\n  border-radius: 9px;\n}\n\n.gf-intake__consent-meta-row {\n  display: grid;\n  grid-template-columns: 92px 1fr;\n  gap: 10px;\n  align-items: start;\n}\n\n.gf-intake__consent-meta-row dt {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: var(--gf-faint);\n}\n\n.gf-intake__consent-meta-row dd {\n  margin: 0;\n  font-size: 11.5px;\n  line-height: 1.55;\n  color: var(--gf-muted);\n}\n\n.gf-intake__error {\n  margin: 18px 0 0;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--error, #d24b4b);\n}\n\n/* ── 푸터 (고정) ── */\n.gf-intake__foot {\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 34px;\n  border-top: 1px solid var(--gf-line);\n  background: #fff;\n}\n\n.gf-intake__foot-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.gf-intake__btn {\n  height: 46px;\n  padding: 0 22px;\n  font-size: 13.5px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  font-family: inherit;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.gf-intake__btn--ghost {\n  color: var(--gf-muted);\n  background: none;\n  border: 1px solid var(--gf-line-strong);\n}\n\n.gf-intake__btn--ghost:hover {\n  color: var(--gf-ink);\n  border-color: var(--gf-navy-soft);\n}\n\n.gf-intake__btn--text {\n  color: var(--gf-muted);\n  background: none;\n  border: none;\n}\n\n.gf-intake__btn--text:hover {\n  color: var(--gf-ink);\n  text-decoration: underline;\n}\n\n.gf-intake__btn--primary {\n  color: #fff;\n  background: var(--gf-navy);\n  border: none;\n}\n\n.gf-intake__btn--primary:hover {\n  background: var(--gf-ink);\n}\n\n.gf-intake__btn--primary:disabled {\n  background: var(--gf-line-strong);\n  cursor: not-allowed;\n}\n\n/* 좁은 화면 */\n@media (max-width: 640px) {\n  .gf-intake { padding: 0; }\n  .gf-intake__card { max-width: none; max-height: 100%; height: 100%; border-radius: 0; }\n  .gf-intake__head { padding: 22px 20px 0; }\n  .gf-intake__body { padding: 20px 20px 26px; }\n  .gf-intake__foot { padding: 14px 20px; }\n  .gf-intake__grid { grid-template-columns: 1fr; }\n  .gf-intake__btn { padding: 0 16px; }\n  .gf-intake__stepper-tag { display: none; }\n}\n\n/* ============================================================\n   매칭 결과(match_report) — 우측 패널\n   적격(녹) / 추가확인(황동) / 아깝게 탈락(약) 3섹션\n   ============================================================ */\n.gf-match {\n  --gf-ok: #2f6f4e;            /* 적격 — 절제된 포레스트 그린 */\n  --gf-ok-bg: rgba(47, 111, 78, 0.07);\n  --gf-warn: var(--gf-brass);  /* 추가확인 — 황동 */\n  --gf-warn-bg: rgba(154, 123, 79, 0.10);\n  --gf-warn-ink: #7a5d33;      /* 황동 칩 텍스트 — WCAG AA 확보용 어두운 톤 */\n  --gf-danger: #c2410c;        /* 마감 임박 — 어스톤 번트레드(네이비/그린/황동과 조화) */\n  --gf-danger-bg: rgba(194, 65, 12, 0.10);\n}\n\n/* 탭 — 신청 가능 / 추가 확인 / 아깝게 탈락 */\n.gf-match__tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-match__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 13px;\n  margin-bottom: -1px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--gf-muted);\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: var(--transition-fast, 0.15s ease);\n}\n.gf-match__tab:hover { color: var(--gf-ink); }\n\n.gf-match__tab-count {\n  font-size: 11px;\n  font-weight: 700;\n  min-width: 18px;\n  padding: 1px 6px;\n  border-radius: var(--radius-full, 9999px);\n  color: var(--gf-muted);\n  background: rgba(19, 49, 79, 0.08);\n}\n\n.gf-match__tab.is-on { color: var(--gf-ink); border-bottom-color: var(--gf-navy); }\n.gf-match__tab--eligible.is-on { color: var(--gf-ok); border-bottom-color: var(--gf-ok); }\n.gf-match__tab--eligible.is-on .gf-match__tab-count { color: #fff; background: var(--gf-ok); }\n.gf-match__tab--warn.is-on,\n.gf-match__tab--needs.is-on { color: var(--gf-warn); border-bottom-color: var(--gf-warn); }\n.gf-match__tab--needs.is-on .gf-match__tab-count { color: #fff; background: var(--gf-warn); }\n.gf-match__tab--near.is-on { color: var(--gf-ink); border-bottom-color: var(--gf-line-strong); }\n.gf-match__tab--near.is-on .gf-match__tab-count { color: #fff; background: var(--gf-navy-soft); }\n\n.gf-match__list { display: flex; flex-direction: column; }\n\n.gf-match__hint {\n  font-size: 12px;\n  color: var(--gf-muted);\n  line-height: 1.5;\n  padding: 4px 0 10px;\n}\n\n.gf-match__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 13px 10px;\n  margin: 0 -10px;              /* hover 배경만 살짝 바깥으로, 구분선은 본문 폭 유지 */\n  border-bottom: 1px solid var(--gf-line);\n  border-radius: 8px;\n}\n.gf-match__row:last-child { border-bottom: none; }\n\n/* 상태 구분은 탭(신청가능/추가확인/아깝게탈락)이 담당 — 행 좌측 컬러바는 제거.\n   탭 안의 모든 행이 동일 상태라 좌측 보더는 정보 중복이었다. */\n\n.gf-match__main { flex: 1; min-width: 0; }\n\n.gf-match__name {\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink);\n  line-height: 1.4;\n}\n\n.gf-match__meta {\n  font-size: 12px;\n  color: var(--gf-muted);\n  margin-top: 3px;\n}\n\n.gf-match__sum {\n  font-size: 12.5px;\n  color: var(--gf-navy-soft);\n  line-height: 1.55;\n  margin-top: 6px;\n}\n\n/* 누락/미달 차원 — 인라인 텍스트 대신 칩으로(반복되는 행 사이에서 시선 앵커) */\n.gf-match__tags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n}\n.gf-match__tags-pre {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--gf-faint);\n  letter-spacing: 0.02em;\n}\n.gf-match__tag {\n  font-size: 11.5px;\n  font-weight: 600;\n  line-height: 1.4;\n  padding: 2px 9px;\n  border-radius: var(--radius-full, 9999px);\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n.gf-match__tag--warn { color: var(--gf-warn-ink); background: var(--gf-warn-bg); }\n.gf-match__tag--miss { color: var(--gf-navy-soft); background: rgba(19, 49, 79, 0.07); }\n\n.gf-match__link {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  text-decoration: none;\n  margin-top: 8px;\n}\n.gf-match__link:hover { text-decoration: underline; }\n\n/* 우측 부가 영역 — 마감 배지 + 클릭 셰브론 세로 정렬 */\n.gf-match__aside {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 9px;\n  padding-top: 1px;\n}\n\n/* 마감 배지 — 톤별 pill. 상시·임박·마감을 색으로 분리(임박이 가장 강하게). */\n.gf-match__dday {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11.5px;\n  font-weight: 700;\n  white-space: nowrap;\n  padding: 2px 9px;\n  border-radius: var(--radius-full, 9999px);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.01em;\n}\n.gf-match__dday--always { font-weight: 600; color: var(--gf-faint); background: rgba(19, 49, 79, 0.06); }\n.gf-match__dday--normal { color: var(--gf-navy-soft); background: rgba(19, 49, 79, 0.07); }\n.gf-match__dday--soon { color: var(--gf-navy); background: rgba(19, 49, 79, 0.11); }\n.gf-match__dday--urgent { color: var(--gf-danger); background: var(--gf-danger-bg); }\n.gf-match__dday--closed { font-weight: 600; color: var(--gf-faint); background: rgba(19, 49, 79, 0.05); text-decoration: line-through; }\n\n/* 클릭 가능 행 신호 — 평소 옅게, hover 시 네이비로 또렷이 */\n.gf-match__chev {\n  display: inline-flex;\n  color: var(--gf-faint);\n  opacity: 0;\n  transition: opacity 0.15s ease, color 0.15s ease;\n}\n.gf-match__row--click .gf-match__chev { opacity: 0.45; }\n.gf-match__row--click:hover .gf-match__chev { opacity: 1; color: var(--gf-navy); }\n\n.gf-match__empty {\n  font-size: 13px;\n  color: var(--gf-muted);\n  text-align: center;\n  padding: 28px 12px;\n}\n\n/* 추가확인 페이지네이션 */\n.gf-match__pager {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 14px 0 4px;\n}\n.gf-match__pager-btn {\n  border: 1px solid var(--gf-line);\n  background: #fff;\n  color: var(--gf-navy, #13314f);\n  font-size: 12.5px;\n  font-weight: 600;\n  border-radius: 7px;\n  padding: 6px 14px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.gf-match__pager-btn:hover:not(:disabled) {\n  background: #f2f5f8;\n  border-color: var(--gf-navy, #13314f);\n}\n.gf-match__pager-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n.gf-match__pager-info {\n  font-size: 12px;\n  color: var(--gf-muted);\n  font-variant-numeric: tabular-nums;\n  min-width: 110px;\n  text-align: center;\n}\n\n.gf-match__foot {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--gf-line);\n  font-size: 11.5px;\n  color: var(--gf-muted);        /* faint(대비 ~3:1)는 AA 미달 — muted로 상향 */\n  letter-spacing: 0.01em;\n}\n\n/* ============================================================\n   추가 질문(paused) — 대화 흐름 안\n   ============================================================ */\n.gf-qa {\n  margin-top: 10px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid var(--gf-line);\n  border-radius: var(--radius-lg, 8px);\n}\n\n.gf-qa__item { margin-bottom: 14px; }\n.gf-qa__item:last-of-type { margin-bottom: 6px; }\n\n.gf-qa__label {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--gf-ink);\n  line-height: 1.45;\n  margin-bottom: 9px;\n}\n\n.gf-qa__opts { display: flex; flex-wrap: wrap; gap: 8px; }\n\n.gf-qa__opt {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--gf-navy);\n  padding: 7px 14px;\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: var(--radius-full, 9999px);\n  cursor: pointer;\n  transition: var(--transition-fast, 0.15s ease);\n}\n.gf-qa__opt:hover:not(:disabled) { color: #fff; background: var(--gf-navy); border-color: var(--gf-navy); }\n.gf-qa__opt:disabled { opacity: 0.5; cursor: default; }\n\n.gf-qa__hint {\n  font-size: 11.5px;\n  color: var(--gf-faint);\n  margin-top: 4px;\n}\n\n/* ============================================================\n   정밀판정(program_verdict) — §4 \"자세히 보기\" 응답 카드\n   ============================================================ */\n.gf-verdict { display: flex; flex-direction: column; }\n.gf-verdict__head { margin-bottom: 4px; }\n\n.gf-verdict__badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  padding: 4px 12px;\n  border-radius: var(--radius-full, 9999px);\n  margin-bottom: 10px;\n}\n.gf-verdict__badge--ok    { color: var(--gf-ok); background: var(--gf-ok-bg); }\n.gf-verdict__badge--warn  { color: var(--gf-warn-ink); background: var(--gf-warn-bg); }\n.gf-verdict__badge--miss  { color: var(--gf-danger); background: var(--gf-danger-bg); }\n.gf-verdict__badge--muted { color: var(--gf-muted); background: rgba(19, 49, 79, 0.07); }\n\n.gf-verdict__title {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--gf-ink);\n  line-height: 1.4;\n  margin: 0;\n}\n.gf-verdict__meta { font-size: 12.5px; color: var(--gf-muted); margin-top: 4px; }\n\n.gf-verdict__sec {\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid var(--gf-line);\n}\n.gf-verdict__sec-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--gf-navy-soft);\n  margin: 0 0 10px;\n}\n.gf-verdict__sec-sub { font-size: 12px; color: var(--gf-muted); margin: -6px 0 10px; line-height: 1.5; }\n\n.gf-verdict__chips { display: flex; flex-wrap: wrap; gap: 7px; }\n.gf-verdict__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 11px;\n  border-radius: var(--radius-full, 9999px);\n}\n.gf-verdict__chip--ok { color: var(--gf-ok); background: var(--gf-ok-bg); }\n.gf-verdict__chip-ic { display: inline-flex; }\n.gf-verdict__chip-ic svg { width: 11px; height: 11px; }\n\n.gf-verdict__fails { display: flex; flex-direction: column; gap: 12px; }\n.gf-verdict__fail { display: flex; flex-direction: column; gap: 4px; }\n.gf-verdict__fail-label { font-size: 13px; font-weight: 600; color: var(--gf-danger); }\n.gf-verdict__fail-text { font-size: 12px; line-height: 1.55; color: var(--gf-navy-soft); }\n\n/* self-attest 체크 — 실제 input 은 투명 오버레이, box 가 시각 표시 */\n.gf-verdict__attest { display: flex; flex-direction: column; gap: 8px; }\n.gf-verdict__attest-row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 11px;\n  border: 1px solid var(--gf-line);\n  border-radius: var(--radius-md, 8px);\n  cursor: pointer;\n  transition: var(--transition-fast, 0.15s ease);\n}\n.gf-verdict__attest-row:hover { border-color: var(--gf-line-strong); }\n.gf-verdict__attest-row.is-on { border-color: var(--gf-ok); background: var(--gf-ok-bg); }\n.gf-verdict__attest-cb { position: absolute; inset: 0; margin: 0; opacity: 0; cursor: pointer; }\n.gf-verdict__attest-box {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: grid;\n  place-items: center;\n  border: 1.5px solid var(--gf-line-strong);\n  border-radius: 5px;\n  color: #fff;\n}\n.gf-verdict__attest-row.is-on .gf-verdict__attest-box { background: var(--gf-ok); border-color: var(--gf-ok); }\n.gf-verdict__attest-box svg { width: 11px; height: 11px; }\n.gf-verdict__attest-label { font-size: 13px; font-weight: 500; color: var(--gf-ink); }\n\n.gf-verdict__q { margin-bottom: 12px; }\n.gf-verdict__q:last-child { margin-bottom: 0; }\n.gf-verdict__q-label { font-size: 13px; font-weight: 600; color: var(--gf-ink); margin-bottom: 8px; line-height: 1.45; }\n.gf-verdict__q-opts { display: flex; flex-wrap: wrap; gap: 7px; }\n.gf-verdict__q-opt {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--gf-navy);\n  padding: 6px 13px;\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: var(--radius-full, 9999px);\n  cursor: pointer;\n  transition: var(--transition-fast, 0.15s ease);\n}\n.gf-verdict__q-opt:hover:not(:disabled),\n.gf-verdict__q-opt.is-on { color: #fff; background: var(--gf-navy); border-color: var(--gf-navy); }\n.gf-verdict__q-opt:disabled { opacity: 0.5; cursor: default; }\n\n.gf-verdict__blockers { display: flex; flex-direction: column; gap: 10px; }\n.gf-verdict__blocker {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 10px 12px;\n  background: rgba(19, 49, 79, 0.04);\n  border-radius: var(--radius-md, 8px);\n}\n.gf-verdict__blocker-reason { font-size: 12.5px; font-weight: 600; color: var(--gf-navy-soft); }\n.gf-verdict__blocker-text { font-size: 12px; line-height: 1.55; color: var(--gf-muted); }\n\n.gf-verdict__note { margin-top: 16px; font-size: 12.5px; line-height: 1.6; color: var(--gf-muted); }\n\n.gf-verdict__actions { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 20px; }\n.gf-verdict__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 16px;\n  border-radius: var(--radius-md, 8px);\n  cursor: pointer;\n  text-decoration: none;\n  border: 1px solid transparent;\n  transition: var(--transition-fast, 0.15s ease);\n}\n.gf-verdict__btn--primary { color: #fff; background: var(--gf-navy); }\n.gf-verdict__btn--primary:hover:not(:disabled) { background: var(--gf-ink); }\n.gf-verdict__btn--primary:disabled { opacity: 0.45; cursor: default; }\n.gf-verdict__btn--ghost { color: var(--gf-navy); background: #fff; border-color: var(--gf-line-strong); }\n.gf-verdict__btn--ghost:hover { background: #f2f5f8; border-color: var(--gf-navy); }\n\n.gf-verdict__foot {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--gf-line);\n  font-size: 11.5px;\n  color: var(--gf-muted);\n}\n\n/* ============================================================\n   신청서 초안(application_draft) — §6 고정 5섹션 점증 doc\n   ============================================================ */\n.gf-draft { display: flex; flex-direction: column; }\n.gf-draft__head { margin-bottom: 14px; }\n.gf-draft__title { font-size: 16px; font-weight: 700; letter-spacing: -0.01em; color: var(--gf-ink); line-height: 1.4; margin: 0; }\n.gf-draft__meta { font-size: 12.5px; color: var(--gf-muted); margin-top: 4px; }\n\n.gf-draft__progress { margin-bottom: 4px; }\n.gf-draft__progress-head { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 6px; }\n.gf-draft__progress-label { font-size: 12px; font-weight: 600; color: var(--gf-navy-soft); }\n.gf-draft__progress-count { font-size: 12px; font-weight: 700; color: var(--gf-navy); font-variant-numeric: tabular-nums; }\n.gf-draft__progress-bar { height: 6px; border-radius: var(--radius-full, 9999px); background: rgba(19, 49, 79, 0.10); overflow: hidden; }\n.gf-draft__progress-fill { display: block; height: 100%; border-radius: inherit; background: var(--gf-navy); transition: width 0.4s ease; }\n\n.gf-draft__hint { font-size: 12px; color: var(--gf-muted); line-height: 1.5; margin: 10px 0 4px; }\n\n.gf-draft__sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin-top: 14px;\n  background: var(--gf-line);\n  border: 1px solid var(--gf-line);\n  border-radius: var(--radius-lg, 8px);\n  overflow: hidden;\n}\n.gf-draft__sec { background: #fff; padding: 14px; }\n.gf-draft__sec--stub { background: #fafafb; }\n.gf-draft__sec-head { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 7px; }\n.gf-draft__sec-label { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }\n.gf-draft__sec-status {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 9px;\n  border-radius: var(--radius-full, 9999px);\n  letter-spacing: -0.01em;\n}\n.gf-draft__sec-status--done { color: var(--gf-ok); background: var(--gf-ok-bg); }\n.gf-draft__sec-status--pending { color: var(--gf-faint); background: rgba(19, 49, 79, 0.06); }\n.gf-draft__sec-status--stub { color: var(--gf-warn-ink); background: var(--gf-warn-bg); }\n.gf-draft__sec-body { font-size: 12.5px; line-height: 1.6; color: var(--gf-navy-soft); margin: 0; white-space: pre-wrap; }\n.gf-draft__sec-body--stub { color: var(--gf-muted); font-style: italic; }\n.gf-draft__sec-body--empty { color: var(--gf-faint); }\n\n.gf-draft__complete {\n  margin-top: 14px;\n  padding: 12px 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gf-ok);\n  background: var(--gf-ok-bg);\n  border-radius: var(--radius-md, 8px);\n  line-height: 1.5;\n}\n.gf-draft__disclaimer { margin-top: 12px; font-size: 11.5px; line-height: 1.6; color: var(--gf-muted); }\n.gf-draft__foot { margin-top: 10px; font-size: 11.5px; color: var(--gf-faint); }\n\n/* 에이전트 타이핑 인디케이터 */\n.gf-msg__text--typing {\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n}\n.gf-msg__text--typing span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--gf-faint);\n  animation: gfTyping 1.2s infinite ease-in-out;\n}\n.gf-msg__text--typing span:nth-child(2) { animation-delay: 0.15s; }\n.gf-msg__text--typing span:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes gfTyping {\n  0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }\n  30% { opacity: 1; transform: translateY(-3px); }\n}\n\n/* SSE 진행 문장(스피너 + 노드별 label) — 한 줄, 텍스트만 교체 */\n.gf-msg__progress {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  max-width: 100%;\n  padding: 11px 15px;\n  background: #fff;\n  border: 1px solid var(--gf-line);\n  border-radius: 12px;\n  font-size: 14px;\n  color: var(--gf-ink);\n}\n\n.gf-msg__spinner {\n  flex: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  border: 2.5px solid var(--gf-line-strong);\n  border-top-color: var(--gf-navy);\n  animation: gfSpin 0.7s linear infinite;\n}\n\n@keyframes gfSpin {\n  to { transform: rotate(360deg); }\n}\n\n.gf-msg__progress-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* 에이전트 버블 마크다운 */\n.gf-msg__md { line-height: 1.6; }\n.gf-msg__md > :first-child { margin-top: 0; }\n.gf-msg__md > :last-child { margin-bottom: 0; }\n.gf-msg__md p { margin: 0 0 8px; }\n.gf-msg__md ol,\n.gf-msg__md ul { margin: 6px 0 10px; padding-left: 20px; }\n.gf-msg__md li { margin: 3px 0; }\n.gf-msg__md h1,\n.gf-msg__md h2,\n.gf-msg__md h3,\n.gf-msg__md h4 { font-size: 14px; font-weight: 700; margin: 14px 0 7px; color: var(--gf-ink); }\n.gf-msg__md strong { font-weight: 700; color: var(--gf-ink); }\n.gf-msg__md a { color: var(--gf-navy); text-decoration: underline; }\n.gf-msg__md hr { border: none; border-top: 1px solid var(--gf-line); margin: 14px 0; }\n.gf-msg__md code {\n  font-size: 0.9em;\n  padding: 1px 5px;\n  border-radius: var(--radius-sm, 4px);\n  background: rgba(19, 49, 79, 0.06);\n}\n.gf-msg__md pre {\n  background: var(--gf-ink);\n  color: #e7dcc6;\n  padding: 12px 14px;\n  border-radius: var(--radius-md, 6px);\n  overflow-x: auto;\n  margin: 8px 0;\n}\n.gf-msg__md pre code { background: none; padding: 0; color: inherit; }\n.gf-msg__md table { border-collapse: collapse; margin: 8px 0; font-size: 12.5px; }\n.gf-msg__md th,\n.gf-msg__md td { border: 1px solid var(--gf-line); padding: 5px 9px; text-align: left; }\n\n/* 매칭 결과 행 — 클릭 가능(공고 상세로 이동) */\n.gf-match__row--click { cursor: pointer; transition: background var(--transition-fast, 0.15s ease); }\n.gf-match__row--click:hover { background: var(--gf-ok-bg); }\n.gf-match__row--warn.gf-match__row--click:hover { background: var(--gf-warn-bg); }\n.gf-match__row--miss.gf-match__row--click:hover { background: rgba(14, 27, 43, 0.04); }\n.gf-match__row--click:focus-visible { outline: 2px solid var(--gf-navy); outline-offset: -2px; }\n\n/* ============================================================\n   공고 상세(GET /programs/{id}) — 패널 상세 뷰\n   ============================================================ */\n.gf-pd { display: flex; flex-direction: column; }\n\n.gf-pd__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  padding: 6px 10px 6px 2px;\n  margin-bottom: 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.gf-pd__back:hover { color: var(--gf-ink); }\n.gf-pd__back span { font-size: 15px; }\n\n.gf-pd__state { font-size: 13px; color: var(--gf-muted); padding: 24px 4px; text-align: center; }\n.gf-pd__state--err { color: var(--rust, #a8412a); }\n\n.gf-pd__title {\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  line-height: 1.35;\n  color: var(--gf-ink);\n}\n\n.gf-pd__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  color: var(--gf-muted);\n  margin-top: 8px;\n}\n.gf-pd__status {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: var(--radius-full, 9999px);\n  color: var(--gf-navy);\n  background: rgba(19, 49, 79, 0.08);\n}\n.gf-pd__dday { font-size: 12px; font-weight: 700; color: var(--gf-navy); }\n\n.gf-pd__summary {\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--gf-navy-soft);\n  margin-top: 14px;\n  padding: 13px 15px;\n  background: var(--gf-ok-bg, rgba(47, 111, 78, 0.06));\n  border-radius: var(--radius-md, 6px);\n}\n\n/* 공고 상세 → 정밀판정 CTA (§4 — 내용 확인 후 명시적 요청) */\n.gf-pd__verdict {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-top: 16px;\n  padding: 14px 16px;\n  background: rgba(19, 49, 79, 0.05);\n  border: 1px solid var(--gf-line);\n  border-radius: var(--radius-lg, 8px);\n}\n.gf-pd__verdict-text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.gf-pd__verdict-text strong { font-size: 13.5px; font-weight: 700; color: var(--gf-ink); letter-spacing: -0.01em; }\n.gf-pd__verdict-text span { font-size: 12px; color: var(--gf-muted); line-height: 1.5; }\n.gf-pd__verdict-btn {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: var(--gf-navy);\n  border: 1px solid var(--gf-navy);\n  border-radius: var(--radius-md, 8px);\n  padding: 9px 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: var(--transition-fast, 0.15s ease);\n}\n.gf-pd__verdict-btn:hover:not(:disabled) { background: var(--gf-ink); border-color: var(--gf-ink); }\n.gf-pd__verdict-btn:disabled { opacity: 0.45; cursor: default; }\n\n@media (max-width: 720px) {\n  .gf-pd__verdict { flex-direction: column; align-items: stretch; }\n  .gf-pd__verdict-btn { width: 100%; }\n}\n\n.gf-pd__sec { margin-top: 24px; }\n.gf-pd__sec-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--gf-ink);\n  padding-bottom: 8px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid var(--gf-line);\n}\n\n.gf-pd__support {\n  padding: 11px 0;\n  border-bottom: 1px solid var(--gf-line);\n}\n.gf-pd__support:last-child { border-bottom: none; }\n.gf-pd__support-head { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }\n.gf-pd__support-item { font-size: 13.5px; font-weight: 600; color: var(--gf-ink); }\n.gf-pd__support-amount { font-size: 13px; font-weight: 700; color: var(--gf-ok, #2f6f4e); white-space: nowrap; }\n.gf-pd__support-detail { font-size: 12.5px; color: var(--gf-muted); line-height: 1.55; margin-top: 5px; }\n.gf-pd__support-cond { font-size: 12px; color: var(--gf-faint); margin-top: 5px; }\n\n.gf-pd__crit {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--gf-line);\n}\n.gf-pd__crit:last-child { border-bottom: none; }\n.gf-pd__crit-tag {\n  align-self: flex-start;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 9px;\n  border-radius: var(--radius-full, 9999px);\n  border: 1px solid var(--gf-line-strong);\n  color: var(--gf-muted);\n}\n.gf-pd__crit-tag--hard { color: var(--rust, #a8412a); border-color: rgba(168, 65, 42, 0.35); }\n.gf-pd__crit-tag--soft { color: var(--gf-brass); border-color: rgba(154, 123, 79, 0.4); }\n.gf-pd__crit-text { font-size: 12.5px; line-height: 1.55; color: var(--gf-navy-soft); }\n\n.gf-pd__file {\n  display: block;\n  font-size: 12.5px;\n  color: var(--gf-navy);\n  text-decoration: none;\n  padding: 7px 0;\n  border-bottom: 1px solid var(--gf-line);\n}\n.gf-pd__file:last-of-type { border-bottom: none; }\n.gf-pd__file:hover { text-decoration: underline; }\n.gf-pd__file::before { content: \"↧ \"; color: var(--gf-faint); }\n\n/* 공고문 인라인 미리보기 (Google Docs Viewer iframe) */\n.gf-pd__preview {\n  position: relative;\n  height: min(760px, 78vh);\n  background: #e9e7e2;\n  border: 1px solid var(--gf-line);\n  border-radius: var(--radius-md, 6px);\n  overflow: hidden;\n}\n.gf-pd__preview-frame {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n}\n.gf-pd__preview-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12.5px;\n  color: var(--gf-muted);\n  pointer-events: none;\n}\n.gf-pd__preview-note {\n  margin: 8px 0 0;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: var(--gf-faint);\n}\n\n.gf-pd__doc {\n  font-size: 12.5px;\n  line-height: 1.7;\n  color: var(--gf-muted);\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 360px;\n  overflow-y: auto;\n  padding: 13px 15px;\n  background: rgba(19, 49, 79, 0.03);\n  border: 1px solid var(--gf-line);\n  border-radius: var(--radius-md, 6px);\n}\n\n.gf-pd__source {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  text-decoration: none;\n  margin-top: 22px;\n}\n.gf-pd__source:hover { text-decoration: underline; }\n\n/* ========================================================================\n   모바일 (≤720px) — AgentShowcase [2단계].\n   히어로/번호 칼럼을 좁은 화면에 맞춰 축소. 인덱스는 이미 세로 리스트라 구조는 유지.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* ① 콘텐츠 패딩 leak 차단 — showcase 비-미디어 .prompt__content(56/60)가\n     Agent.css 모바일 패딩(16/14)을 덮어써 본문이 ~220px 로 짜부되던 문제.\n     같은 파일 뒤쪽 + 미디어 매칭이라 이 규칙이 이긴다. */\n  .gf-showcase-page .prompt__content { padding: 18px 16px 56px; }\n\n  /* ② 마스트헤드 */\n  .gf-showcase-page .gf-showcase__headline { font-size: 26px; margin-top: 14px; }\n  .gf-showcase-page .gf-showcase__deck { font-size: 13.5px; margin-top: 14px; }\n  .gf-showcase-page .gf-showcase__rule { margin-top: 26px; }\n\n  /* ③ 인덱스 행 — 번호 축소 + 화살표 숨김(행 전체 탭 가능), 번호|본문 2열 */\n  .gf-showcase-page .gf-item {\n    grid-template-columns: 34px 1fr;\n    gap: 6px 10px;\n    padding: 18px 2px 16px;\n  }\n  .gf-showcase-page .gf-item__num { font-size: 22px; }\n  .gf-showcase-page .gf-item__arrow { display: none; }\n  .gf-showcase-page .gf-item__name { font-size: 18px; }\n  /* 공식 배지는 이름 아래 줄로(인라인 줄바꿈 깨짐 방지) */\n  .gf-showcase-page .gf-item__official { display: block; margin: 5px 0 0; }\n  .gf-showcase-page .gf-item__desc { font-size: 13px; margin-top: 8px; }\n  .gf-showcase-page .gf-item__meta { margin-top: 12px; flex-wrap: wrap; gap: 4px 8px; }\n}\n\n/* ============================================================\n   리서치(idea-research) — 입구 카드 (.gf-ric)\n   필수 1 + ★ 2(확신·목표) + 선택. 네이비 톤 단일 카드.\n   ============================================================ */\n.gf-ric {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n}\n.gf-ric__scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(8, 16, 28, 0.46);\n  backdrop-filter: blur(2px);\n}\n.gf-ric__card {\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 30px 60px -28px rgba(8, 16, 28, 0.55);\n  overflow: hidden;\n  animation: gfRise 0.5s cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n.gf-ric__head {\n  flex: none;\n  padding: 22px 24px 16px;\n  background: var(--gf-navy);\n  color: #fff;\n}\n.gf-ric__eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.62);\n}\n.gf-ric__title {\n  margin: 6px 0 4px;\n  font-size: 21px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n.gf-ric__sub {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.78);\n}\n.gf-ric__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px 6px;\n}\n.gf-ric__fld { margin-bottom: 16px; }\n.gf-ric__lbl {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--gf-ink);\n  margin-bottom: 7px;\n}\n.gf-ric__tag {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: var(--gf-muted);\n  background: rgba(14, 27, 43, 0.06);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n.gf-ric__tag--req { color: #fff; background: var(--gf-navy); }\n.gf-ric__ctrl {\n  width: 100%;\n  font: inherit;\n  font-size: 14px;\n  color: var(--gf-ink);\n  background: #f7f9fc;\n  border: 1.5px solid var(--gf-line-strong);\n  border-radius: 11px;\n  padding: 11px 13px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.gf-ric__ctrl::placeholder { color: var(--gf-faint); }\n.gf-ric__ctrl:focus {\n  outline: none;\n  border-color: var(--gf-navy);\n  background: #fff;\n}\n.gf-ric__ctrl--err { border-color: #b4452f; background: #fdf3f1; }\n.gf-ric__area { resize: vertical; min-height: 58px; line-height: 1.5; }\n.gf-ric__err { margin: 6px 0 0; font-size: 11.5px; color: #b4452f; }\n\n/* ★ 창업자 직접 입력 — 강조 필드 */\n.gf-ric__fld--star {\n  background: rgba(19, 49, 79, 0.045);\n  border: 1px solid rgba(19, 49, 79, 0.12);\n  border-radius: 13px;\n  padding: 13px 14px;\n}\n.gf-ric__fld--star .gf-ric__ctrl { background: #fff; }\n.gf-ric__star {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #fff;\n  background: var(--gf-navy);\n  border-radius: 5px;\n  padding: 2px 6px;\n}\n.gf-ric__micro {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 7px 0 0;\n  font-size: 11px;\n  color: var(--gf-navy-soft);\n}\n.gf-ric__micro::before {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: none;\n}\n.gf-ric__micro--faint { color: var(--gf-faint); }\n\n/* 목표 규모 segmented */\n.gf-ric__seg {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 7px;\n}\n.gf-ric__seg-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 10px 6px;\n  font: inherit;\n  background: #fff;\n  border: 1.5px solid var(--gf-line-strong);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.gf-ric__seg-btn:hover { border-color: var(--gf-navy-soft); }\n.gf-ric__seg-btn.is-on {\n  background: var(--gf-navy);\n  border-color: var(--gf-navy);\n  box-shadow: 0 6px 14px -8px rgba(19, 49, 79, 0.7);\n}\n.gf-ric__seg-main { font-size: 13px; font-weight: 700; color: var(--gf-ink); }\n.gf-ric__seg-hint { font-size: 10px; color: var(--gf-muted); }\n.gf-ric__seg-btn.is-on .gf-ric__seg-main,\n.gf-ric__seg-btn.is-on .gf-ric__seg-hint { color: #fff; }\n.gf-ric__seg-btn.is-on .gf-ric__seg-hint { color: rgba(255, 255, 255, 0.72); }\n\n.gf-ric__optbar {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 18px 0 14px;\n  padding-top: 14px;\n  border-top: 1px dashed var(--gf-line-strong);\n}\n.gf-ric__optbar-ttl { font-size: 12px; font-weight: 600; color: var(--gf-muted); }\n.gf-ric__row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }\n.gf-ric__row2 .gf-ric__fld { margin-bottom: 0; }\n\n.gf-ric__foot {\n  flex: none;\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  padding: 14px 24px 6px;\n  border-top: 1px solid var(--gf-line);\n}\n.gf-ric__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 42px;\n  padding: 0 20px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  border-radius: 11px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.gf-ric__btn--ghost { color: var(--gf-muted); background: none; border-color: var(--gf-line-strong); }\n.gf-ric__btn--ghost:hover { color: var(--gf-ink); border-color: var(--gf-navy-soft); }\n.gf-ric__btn--primary { color: #fff; background: var(--gf-navy); box-shadow: 0 12px 24px -12px rgba(19, 49, 79, 0.8); }\n.gf-ric__btn--primary:hover { background: var(--gf-ink); }\n.gf-ric__btn:disabled { opacity: 0.55; cursor: default; }\n.gf-ric__note {\n  margin: 0;\n  padding: 6px 24px 18px;\n  font-size: 11px;\n  color: var(--gf-faint);\n  text-align: center;\n}\n\n/* ============================================================\n   리서치 — 검증 리포트 패널 (.gf-rp, 우측 읽기 전용)\n   · 툴바는 입력창 위(.gf-work__rtoolbar)\n   · 버튼/질문 결과는 채팅 인라인(.gf-msg__rart)\n   ============================================================ */\n.gf-work__panel--research {\n  /* 폭은 매칭 결과 패널(.gf-work__panel)과 동일 — 기본 880px + 동일 반응형(620/460) 상속 */\n  animation: gfFadeIn 0.32s ease;\n}\n.gf-rp { display: block; }\n.gf-rp__placeholder { font-size: 13px; color: var(--gf-muted); }\n.gf-rp__banner {\n  margin: 0 0 12px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: var(--gf-warn);\n  background: var(--gf-warn-bg);\n  border: 1px solid rgba(154, 123, 79, 0.3);\n  border-radius: 9px;\n}\n.gf-rp__steps { margin: 6px 0 0; padding-left: 18px; font-size: 13px; color: var(--gf-ink); line-height: 1.6; }\n.gf-rp__steps li { margin: 4px 0; }\n\n/* 리포트 본문 */\n.gf-rp__title {\n  margin: 0 0 10px;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  line-height: 1.35;\n  color: var(--gf-ink);\n}\n.gf-rp__verdict {\n  margin-bottom: 14px;\n  padding: 12px 13px;\n  background: var(--gf-warn-bg);\n  border: 1px solid rgba(154, 123, 79, 0.3);\n  border-radius: 11px;\n}\n.gf-rp__verdict-tag {\n  display: inline-block;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--gf-warn);\n  margin-bottom: 5px;\n}\n.gf-rp__verdict-r { display: block; font-size: 13px; line-height: 1.55; color: var(--gf-ink); }\n.gf-rp__sec { padding: 10px 0; border-top: 1px solid var(--gf-line); font-size: 13px; color: var(--gf-muted); line-height: 1.6; }\n.gf-rp__sec:first-of-type { border-top: none; }\n.gf-rp__sec-t { display: block; font-size: 12.5px; font-weight: 700; color: var(--gf-ink); margin-bottom: 3px; }\n.gf-rp__sec-b { color: var(--gf-muted); }\n.gf-rp__critic {\n  margin-top: 12px;\n  padding: 12px 14px;\n  background: rgba(19, 49, 79, 0.04);\n  border: 1px solid rgba(19, 49, 79, 0.14);\n  border-radius: 11px;\n}\n.gf-rp__critic-t { font-size: 11.5px; font-weight: 700; color: var(--gf-navy); margin-bottom: 6px; }\n.gf-rp__critic-list { margin: 0; padding-left: 17px; font-size: 12.5px; color: var(--gf-ink); line-height: 1.6; }\n.gf-rp__critic-list li { margin: 3px 0; }\n.gf-rp__gov { margin-top: 12px; padding-top: 10px; border-top: 1px solid var(--gf-line); }\n.gf-rp__kv { display: flex; flex-direction: column; gap: 2px; }\n.gf-rp__kv-row { display: flex; gap: 10px; padding: 4px 0; font-size: 12.5px; }\n.gf-rp__kv-k { min-width: 92px; color: var(--gf-faint); }\n.gf-rp__kv-v { color: var(--gf-ink); font-weight: 600; }\n.gf-rp__empty { font-size: 12px; color: var(--gf-faint); font-style: italic; }\n.gf-rp__md { font-size: 13px; line-height: 1.62; color: var(--gf-ink); }\n.gf-rp__md > :first-child { margin-top: 0; }\n.gf-rp__md > :last-child { margin-bottom: 0; }\n.gf-rp__md h1, .gf-rp__md h2, .gf-rp__md h3, .gf-rp__md h4 { font-size: 13.5px; font-weight: 700; margin: 12px 0 5px; color: var(--gf-ink); }\n.gf-rp__md p { margin: 6px 0; }\n.gf-rp__md ul, .gf-rp__md ol { margin: 6px 0; padding-left: 18px; }\n.gf-rp__md code { font-size: 12px; background: rgba(14, 27, 43, 0.06); padding: 1px 5px; border-radius: 5px; }\n\n/* 입력창 위 액션 바 (.gf-work__rtoolbar) */\n.gf-work__rtoolbar {\n  margin-bottom: 10px;\n  padding: 10px 12px;\n  background: rgba(19, 49, 79, 0.04);\n  border: 1px solid var(--gf-line);\n  border-radius: 12px;\n}\n.gf-work__rtoolbar-h {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--gf-navy);\n  margin-bottom: 8px;\n}\n.gf-work__rtoolbar-row { display: flex; flex-wrap: wrap; gap: 6px; }\n\n/* 액션 버튼(입력창 위 툴바) */\n.gf-rp__tool {\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--gf-navy);\n  background: #fff;\n  border: 1px solid var(--gf-line-strong);\n  border-radius: 8px;\n  padding: 6px 11px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.gf-rp__tool:hover { border-color: var(--gf-navy); background: rgba(19, 49, 79, 0.05); }\n.gf-rp__tool--free { color: var(--gf-brass); border-color: rgba(154, 123, 79, 0.4); background: var(--gf-warn-bg); }\n.gf-rp__tool--free:hover { border-color: var(--gf-brass); }\n.gf-rp__tool:disabled { opacity: 0.45; cursor: default; }\n.gf-rp__tool:disabled:hover { border-color: var(--gf-line-strong); background: #fff; }\n.gf-rp__tool--free:disabled:hover { background: var(--gf-warn-bg); border-color: rgba(154, 123, 79, 0.4); }\n\n/* 채팅 버블 안 인라인 결과 카드 (.gf-msg__rart) */\n.gf-msg__rart {\n  margin-top: 10px;\n  border: 1px solid var(--gf-line);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n.gf-msg__rart-h {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 13px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--gf-ink);\n  background: rgba(19, 49, 79, 0.04);\n  border-bottom: 1px solid var(--gf-line);\n}\n.gf-msg__rart-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--gf-navy); flex: none; }\n.gf-msg__rart-b { padding: 12px 13px; font-size: 12.5px; color: var(--gf-muted); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
